export default {
  // Navigation
  nav: {
    login: 'Logg inn',
    getStarted: 'Kom i gang',
    pricing: 'Priser',
    howItWorks: 'Slik fungerer det',
    joinWaitlist: 'Bli med på ventelisten'
  },

  // Theme
  theme: {
    switchToLight: 'Bytt til lys modus',
    switchToDark: 'Bytt til mørk modus'
  },

  // Burger Menu

  // Common
  common: {
    loading: 'Laster...',
    error: 'Feil',
    cancel: 'Avbryt',
    save: 'Lagre',
    delete: 'Slett',
    remove: 'Fjern',
    edit: 'Rediger',
    change: 'Endre',
    back: 'Tilbake',
    next: 'Neste',
    previous: 'Forrige',
    close: 'Lukk',
    selectAll: 'Velg alle',
    processing: 'Behandler...',
    characters: 'tegn',
    retry: 'Prøv igjen',
    noImage: 'Ingen bilde',
    videoNotSupported: 'Nettleseren din støtter ikke video-taggen.',
    created: 'Opprettet',
    saving: 'Lagrer...',
    saveChanges: 'Lagre endringer',
    create: 'Opprett',
    creating: 'Oppretter...',
    upload: 'Last opp',
    uploading: 'Laster opp...',
    sending: 'Sender...',
    test: 'Test',
    or: 'eller',
    generatingContent: 'Genererer innhold...',
    justNow: 'Akkurat nå',
    minuteAgo: 'minutt siden',
    minutesAgo: 'minutter siden',
    pagination: {
      previous: '← Forrige',
      next: 'Neste →',
      pageInfo: 'Side {current} av {total} ({count} totalt)'
    },
    theme: 'Tema',
    language: 'Språk',
    allRightsReserved: 'Alle rettigheter forbeholdt.',
    dashboard: 'Dashbord',
  },

  // Platforms
  platforms: {
    facebook: 'Facebook',
    instagram: 'Instagram',
    tiktok: 'TikTok',
    twitter: 'Twitter/X',
    linkedin: 'LinkedIn',
    pinterest: 'Pinterest',
    facebookWithIcon: 'Facebook',
    instagramWithIcon: 'Instagram',
    tiktokWithIcon: 'TikTok',
    twitterWithIcon: 'Twitter/X',
    linkedinWithIcon: 'LinkedIn',
    pinterestWithIcon: 'Pinterest'
  },

  // Timezones

  // Auth / Login View
  auth: {
    brandSubtitle: 'AI-drevet innhold for ditt merke',
    email: 'E-post',
    emailPlaceholder: 'din{\'@\'}epost.no',
    signIn: 'Logg inn',
    backToLogin: 'Tilbake til innlogging',
    continueWithApple: 'Fortsett med Apple',
    continueWithGoogle: 'Fortsett med Google',
    continueWithFacebook: 'Fortsett med Facebook',
    signInWithEmail: 'Logg inn med e-post',
    checkEmailForLink: 'Sjekk e-posten din for en innloggingslenke',
    emailConfirmed: 'Suksess! Laster profilen din...',
    pleaseLogin: 'Vennligst logg inn for å fortsette',
    privacyPolicy: 'Personvernerklæring',
    termsOfService: 'Tjenestevilkår',
    lastUsed: 'Sist brukt'
  },

  // Waitlist Landing Page
  waitlist: {
    headline: 'Ditt merkes automatiserte sosiale medier-ansvarlig',
    subheadline: 'Lag fantastisk innhold, planlegg innlegg og utvid merkets tilstedeværelse—alt med AI.',
    emailPlaceholder: 'Skriv inn e-posten din',
    joinButton: 'Bli med på ventelisten',
    joining: 'Registrerer...',
    successTitle: 'Du er på listen!',
    successMessage: 'Vi gir deg beskjed når Social Chef lanseres.',
    alreadyOnList: 'Denne e-posten er allerede på ventelisten',
    invalidEmail: 'Vennligst skriv inn en gyldig e-postadresse',
    error: 'Noe gikk galt. Prøv igjen.',
    loginLink: 'Har du allerede en konto?',
    loginLinkText: 'Logg inn',
    socialProof: 'Bli med {count}+ merker på ventelisten',
    finalCta: {
      title: 'Vær først ute',
      subtitle: 'Bli med på ventelisten og få tidlig tilgang når vi lanserer.'
    }
  },

  // Landing Page
  landing: {
    // Hero Section
    hero: {
      tagline: 'AI-drevet sosiale medier for ditt merke',
      headlinePart1: 'Den kraftigste og',
      headlinePart2: 'enkleste AI-innholds',
      headlinePart3: 'generator for ditt merke',
      headlinePart3Bars: 'generator for barer',
      headlinePart3Yachts: 'generator for yachter',
      headlinePart3Hotels: 'generator for hoteller',
      subheadline: 'Få flotte innlegg på sosiale medier som publiserer seg selv. Ingen fotograf, ingen designer, ingen tekniske ferdigheter nødvendig.',
      cta: 'Kom i gang nå',
      ctaSecondary: 'Se hvordan det fungerer',
      seenOn: 'Omtalt i:',
      features: {
        images: 'Generer bilder',
        videos: 'Lag videoer',
        posts: 'Skriv innlegg',
        publish: 'Auto-publiser',
        analytics: 'Spor analyse'
      }
    },

    // Login Box (inline in hero)
    loginBox: {
      goToDashboard: 'Gå til dashboard'
    },

    // How It Works Showcase Section
    examples: {
      title: 'Slik fungerer det',
      subtitle: 'Fra telefonen din til profesjonelle innlegg på sekunder',
      originalPhoto: 'Ditt bilde',
      originalLabel: 'Original',
      aiGenerated: 'SocialChef-forbedret',
      flow: {
        step1Title: 'Last opp bildet ditt',
        step1Description: 'Ta et bilde av bedriften din med telefonen. Ingen profesjonelt kamera nødvendig.',
        step2Title: 'SocialChef lager flere versjoner',
        step2Description: 'SocialChef genererer vakre varianter i forskjellige stiler, hver med engasjerende tekst.',
        step3Title: 'Godkjenn og publiser',
        step3Description: 'Velg din favorittversjon og den publiseres automatisk til Facebook og Instagram.'
      },
      gallery: {
        before: 'Før',
        after: 'Etter'
      },
      templates: {
        behindTheScenes: 'Bak kulissene',
        studioShot: 'Studioopptak',
        oneBite: 'En bit',
        zoomIn: 'Zoom inn',
        cleanStrict: 'Ren streng',
        infographic: 'Infografikk',
        custom: 'Egendefinert',
        andMore: 'Og mange flere...'
      }
    },

    // Auto-Posting Feature (KEY DIFFERENTIATOR)
    autoPosting: {
      badge: 'Nøkkelfunksjon',
      title: 'Sett det og glem det',
      headline: 'Innleggene dine publiseres automatisk. Virkelig.',
      description: 'Slutt å huske på å poste. Slutt å logge inn i apper. SocialChef håndterer alt - fra opprettelse til publisering. Du vil se ut som om du har en dedikert sosiale medier-ansvarlig.',
      feature1: 'Innlegg går live mens du jobber',
      feature2: 'Fungerer med Instagram og Facebook',
      feature3: 'Planlegg uker i forveien'
    },

    // Benefits
    benefits: {
      title: 'Hvorfor merkeeiere elsker SocialChef',
      time: {
        title: 'Spar timesvis per uke',
        description: 'Slutt å slite med innholdsproduksjon. Bruk tiden på det som betyr noe - bedriften og kundene dine.'
      },
      professional: {
        title: 'Se alltid profesjonell ut',
        description: 'Hvert innlegg ser ut som det ble laget av en proff designer. Fordi det ble det. En AI-designer.'
      },
      growth: {
        title: 'Øk følgerskaren',
        description: 'Konsekvent posting betyr mer engasjement. Mer engasjement betyr flere kunder.'
      },
      easy: {
        title: 'Ingen tekniske ferdigheter nødvendig',
        description: 'Kan du ta et bilde, kan du bruke SocialChef. Så enkelt er det.'
      }
    },

    // Social Proof

    // Pricing Preview
    pricing: {
      title: 'Enkel, ærlig prising',
      subtitle: 'Start i dag. Avslutt når som helst.'
    },

    // Final CTA
    finalCta: {
      title: 'Klar til å si opp sosiale medier-bekymringene?',
      subtitle: 'Bli med hundrevis av merkeeiere som sluttet å stresse over sosiale medier.'
    },

    // Login Modal
    loginModal: {
      title: 'La oss komme i gang',
      subtitle: 'Logg inn for å generere ditt første innlegg'
    },

    // Paywall Modal
    paywall: {
      title: 'Velg din plan',
      subtitle: 'Lås opp automatisk posting og spar timer hver uke',
      autoPostingReminder: 'Alle planer inkluderer automatisk posting til Instagram og Facebook'
    },

    // Footer
    footer: {
      madeWith: 'Laget med kjærlighet for merkeeiere',
      copyright: '© 2025 SocialChef. Alle rettigheter reservert.'
    }
  },

  // Dashboard View
  dashboard: {
    welcomeBack: 'Velkommen, {name}! ',

    // Welcome Modal
    welcomeModalTitle: 'Velkommen til SocialChef!',
    welcomeModalMessage: 'Det ser ut som du ikke har lagt til et merke ennå. La oss komme i gang med å legge til ditt første merke og lage fantastisk innhold!',
    welcomeModalButton: 'La oss starte',

    // Stats
    postsCreated: 'Innlegg opprettet',
    postsSaved: 'Innlegg lagret',
    scheduledPosts: 'Planlagte innlegg',
    restaurants: 'Merker',

    // Quick actions

    // Social platforms

    // Platform descriptions

    // Connection status
    connect: 'Koble til',

    // Account overview
  },

  // Plans View
  plans: {
    brandTitle: 'SocialChef',
    chooseYourPlan: 'Velg din plan',
    unlockPower: 'Lås opp full kraft av AI-generert innhold',
    loading: 'Laster planer...',
    mostPopular: 'Mest populær',
    bestValue: 'Best verdi',
    currentPlan: 'Nåværende plan',
    manageSubscription: 'Administrer abonnement',
    perMonth: '/måned',
    perYear: '/år',
    equalsMonthly: 'kun {price}/mnd',
    oneTime: 'engangsbetaling',
    failedToLoad: 'Kunne ikke laste planer',
    failedToOpenPortal: 'Kunne ikke åpne faktureringsportalen',
    failedToCheckout: 'Kunne ikke opprette betaling',
    networkError: 'Nettverksfeil',
    subscriptionSuccess: 'Abonnement vellykket! Kontoen din vil bli oppdatert snart.',
    subscriptionCanceled: 'Abonnement avbrutt',
    // Trust section
    securePayment: 'Sikker betaling via Stripe',
    cancelAnytime: 'Kanseller når som helst',
    prioritySupport: 'Prioritert støtte',
    // New pricing tier keys
    creditsUpfront: 'poeng på forhånd',
    creditsTotal: 'poeng totalt',
    images: 'bilder',
    videos: 'videoer',
    orEquivalent: 'eller',
    limitedTo: 'Begrenset til {count} personer',
    launchDeal: 'Lanseringstilbud',
    getStarted: 'Abonner',
    upgrade: 'Oppgrader',
    buy: 'Kjøp',
    promoCodeHint: 'Har du en rabattkode? Skriv den inn ved betaling.',
    referralDiscountApplied: 'Din ververabatt blir automatisk brukt ved betaling!',
    imageGeneration: 'AI-bildegenerering',
    videoGeneration: 'AI-videogenerering',
    facebookPublishing: 'Facebook-publisering',
    instagramPublishing: 'Instagram-publisering',
    included: 'Inkludert',
    postScheduling: 'Innleggsplanlegging',
    unlimitedRestaurants: 'Ubegrensede merker',
    noExpiration: 'Poeng utløper aldri',
    subscriptionRequired: 'Et abonnement kreves for å bruke SocialChef. Velg en plan nedenfor for å komme i gang.',
    // Processing states
    activatingSubscription: 'Aktiverer abonnementet ditt',
    paymentReceived: 'Betaling mottatt',
    settingUpAccount: 'Setter opp kontoen din',
    almostReady: 'Nesten klar!',
    processingHint: 'Dette tar vanligvis bare noen sekunder...',
    // Success
    subscriptionActivated: 'Abonnementet er aktivert!',
    // Error/Timeout states
    activationDelayed: 'Tar lengre tid enn forventet',
    activationTakingLong: 'Betalingen din var vellykket, men aktivering av kontoen tar lengre tid enn vanlig. Abonnementet ditt vil snart bli aktivt.',
    checkLater: 'Gå til dashbord',
    contactSupport: 'Hvis dette fortsetter, vennligst kontakt support på support@socialchef.ai'
  },

  // Restaurant Search View
  restaurantSearch: {
    searchPlaceholder: 'Søk merker etter navn eller sted...',
    noResults: 'Ingen merker funnet',

    // Autocomplete
    searchLabel: 'Søk merker',
    searching: 'Søker...',
    searchError: 'Kunne ikke søke etter merker. Vennligst prøv igjen.',
    alreadyAdded: 'Allerede lagt til',

    // Quick Overview

    // Opening Hours

    // Contact & Info

    // Photos

    // Image Upload

    // Social Media

    // Brand Identity

    // Customer Reviews

    // Competitors

    // Menu

    // Actions

    // Messages

    // Progress Modal
  },

  // Onboarding
  onboarding: {
    // Tour steps
    tour: {
      welcomeDetails: [
        'Lag fantastiske innlegg for sosiale medier på sekunder',
        'AI-drevet innholdsgenerering tilpasset merkevaren din',
        'Spar tid mens du opprettholder konsistent kvalitet',
        'Planlegg innlegg og administrer flere plattformer',
      ],

      searchDetails: [
        'Søk etter merker ved hjelp av Google Places',
        'Importer automatisk menyer, bilder og merkevaredetaljer',
        'Bygg din merkedatabase',
        'Få tilgang til omfattende forretningsinformasjon',
      ],

      createDetails: [
        'Generer bilder og videoer med AI',
        'Lag overbevisende bildetekster og hashtags',
        'Tilpass med din merkevareidentitet',
        'Alt generert innhold lagres automatisk',
      ],

      scheduleDetails: [
        'Planlegg innlegg på forhånd',
        'Publiser direkte til Facebook',
        'Administrer flere merker',
        'Spor innholdets ytelse',
      ],

      connectDetails: [
        'Koble til Facebook, Instagram, TikTok og mer',
        'Publiser direkte fra plattformen vår',
        'Administrer alle kontoene dine på ett sted',
        'Sikker OAuth-autentisering',
      ],

      readyDetails: [
        'Start med å legge til merket ditt',
        'Generer ditt første innlegg på minutter',
        'Alt innhold lagres i biblioteket ditt',
        'Planlegg innhold for å opprettholde konsistens',
      ],

      // Navigation
    },

    // Quiz
    quiz: {

      // Questions
      q1Options: ['Koble til sosiale mediekontoer', 'Søk og lagre et merke', 'Generer AI-innhold', 'Planlegg innlegg'],

      q2Options: ['Kun bildegenerering', 'Kun bildetekstskriving', 'Bilder, videoer og bildetekster', 'Kun menydesign'],

      q3Options: ['Kun manuell registrering', 'Google Places og leveringsplattformer', 'Kun sosiale medier', 'Egendefinerte databaser'],

      q4Options: ['Kun laste ned', 'Kun planlegge', 'Lagre, planlegge og publisere til Facebook', 'Kun e-post']
    },

    // Simple onboarding flow
    simple: {
      // Stepper labels
      // Platform descriptions
      // Publish step
      // Completion modal
      // Navigation buttons
    }
  },

  // Playground View
  playground: {
    chooseRestaurant: 'Velg et merke',
    addNewRestaurant: '+ Legg til nytt merke',
    menuItems: 'menyelementer',
    saved: 'Lagret',
    livePreview: 'Forhåndsvisning',
    yourGeneratedImage: 'Ditt genererte bilde',
    previewDescription: 'Forhåndsvis hvordan klistremerket og logoen vil se ut',
    itemsSelected: '{count} element valgt | {count} elementer valgt',
    selectRestaurant: 'Velg merke',

    // Tabs

    // AI Prompts
    generatingIdeas: 'Genererer kreative ideer med AI...',
    aiGeneratedIdeas: 'AI-genererte ideer',
    getNewIdeas: 'Få nye ideer',
    selectedBadge: 'Valgt',

    // Image Generation

    // Post Content
    postContentTitle: 'Innleggsinnhold',

    // Video Generation

    // Restaurant Details Modal

    // Style Templates (Easy Mode)
    styleTemplates: {
      behindTheScenes: {
        name: 'Bak kulissene',
        description: 'Autentisk kjøkkenøyeblikk',
        preview: 'Dokumentarstil matlagingsprosess (fungerer for bilder & videoer)'
      },
      cleanStrict: {
        name: 'Ren og stram',
        description: 'Profesjonell studiokvalitet',
        preview: 'Ren overflate, kinematisk belysning (fungerer for bilder & videoer)'
      },
      zoomIn: {
        name: 'Zoom inn',
        description: 'Ekstrem makronærbilde',
        preview: 'Teksturdetaljer, ASMR-kvalitet (fungerer for bilder & videoer)'
      },
      oneBite: {
        name: 'En bit',
        description: 'Klar-til-å-spise presentasjon',
        preview: 'Tilfredsstillende bit-avslørning (fungerer for bilder & videoer)'
      },
      studioShot: {
        name: 'Studiobilde',
        description: 'Profesjonelt reklameutseende',
        preview: '360-graders omdreining, premium kvalitet (fungerer for bilder & videoer)'
      },
      infographic: {
        name: 'Infografikk',
        description: 'Dekonstruert ingrediensoversikt',
        preview: 'Ingrediensmontering eller merket layout (fungerer for bilder & videoer)'
      },
      placeOnTable: {
        name: 'Plassert på bordet',
        description: 'Retten blir servert',
        preview: 'Hender som plasserer rett på bordet, skaper forventning (KUN VIDEO)'
      },
      custom: {
        name: 'Egendefinert',
        description: 'Skriv din egen prompt',
        preview: 'Full kreativ kontroll (fungerer for bilder & videoer)'
      }
    },

    // Additional messages
  },

  // Easy Mode Creation
  easyMode: {
    steps: {
      menu: 'Meny',
      customize: 'Tilpass',
      preview: 'Forhåndsvisning',
      publish: 'Publiser'
    },
    step1: {
      title: 'Velg rett eller last opp bilde',
      subtitle: 'Velg et menyelement eller last opp ditt eget bilde',
      description: 'Et bilde er påkrevd for å lage innlegget ditt. Velg en rett fra menyen eller last opp ditt eget foto.',
      empty: 'Ingen menyelementer tilgjengelig. Last opp et bilde for å fortsette.',
      imageRequired: 'Vennligst velg et menyelement eller last opp et bilde for å fortsette',
      nextButton: 'Tilpass innlegg'
    },
    step2: {
      title: 'Tilpass innlegget ditt',
      subtitle: 'Velg stil, legg til kampanjer og merkevarebygging',
      styleLabel: 'Visuell stil',
      customPromptPlaceholder: 'Beskriv hvordan du vil at retten skal fotograferes...',
      mediaTypeLabel: 'Medietype',
      imageOption: 'Bilde',
      videoOption: 'Video',
      imageCredits: '1 kreditt',
      videoCredits: '5 kreditter',
      videoOptionsLabel: 'Videoinnstillinger',
      durationLabel: 'Varighet',
      durationWarning: 'Lengre videoer tar lengre tid å generere og kan feile ved høy etterspørsel.',
      seconds: 's',
      aspectRatioLabel: 'Størrelsesforhold',
      portrait: 'Portrett',
      landscape: 'Landskap',
      includeAudio: 'Inkluder AI-generert lyd',
      promoLabel: 'Spesialtilbud (valgfritt)',
      promoPlaceholder: 'f.eks. 20% RABATT, KOMBOTILBUD, NY RETT...',
      logoLabel: 'Merke-logo',
      currentLogo: 'Nåværende logo',
      newLogo: 'Ny logo',
      uploadLogo: 'Last opp logo',
      changeLogo: 'Bytt logo',
      removeLogo: 'Fjern opplastet logo',
      includeLogo: 'Inkluder logo på bildet',
      generateButton: 'Generer bilde',
      generateVideoButton: 'Generer video (5 kreditter)',
      outOfCredits: 'Du har ikke flere kreditter. Vennligst oppgrader planen din for å generere mer innhold.'
    },
    upload: {
      button: 'Last opp ditt eget bilde',
      hint: 'JPG, PNG eller WebP'
    },
    step3: {
      title: 'Forhåndsvis innlegget ditt',
      subtitle: 'Gjennomgå og rediger det genererte innholdet',
      editPostText: 'Rediger innleggsteksten',
      addHashtagPlaceholder: 'Skriv hashtag og trykk Enter',
      animateImage: 'Animer bilde',
      animateCredits: '5 kreditter',
      animationOptionsTitle: 'Videoanimasjonsinnstillinger',
      generateVideoFromImage: 'Generer video',
      generateVideoCredits: '5 kreditter',
      showImage: 'Bilde',
      showVideo: 'Video',
      animatingImage: 'Lager videoanimasjon...',
      insufficientCredits: 'Du trenger minst 5 kreditter for å animere dette bildet',
      noImageToAnimate: 'Ingen bilde tilgjengelig for animering',
      audioDisabledNote: 'Lyd deaktivert for bedre resultater',
      videoGeneratingTitle: 'Video genereres i bakgrunnen...',
      videoGeneratingSubtitle: 'Du kan poste bildet nå. Videoen blir snart klar.',
      videoGeneratingNote: 'Video genereres. Lagre innlegget for å spore fremdriften.'
    },
    step4: {
      title: 'Velg plattform og planlegg',
      subtitle: 'Velg hvor og når du vil publisere',
      successTitle: 'Gratulerer!',
      successMessage: 'Innlegget ditt er publisert!',
      viewOnPlatform: 'Se på {platform}',
      partialFailureWarning: 'Noen plattformer kunne ikke publisere:',
      createAnother: 'Opprett et nytt innlegg'
    }
  },

  // Advanced Mode Creation
  advancedMode: {
    steps: {
      menuSelection: 'Menyelementer',
      customize: 'Tilpass',
      styleSelection: 'Stil',
      preview: 'Forhåndsvisning',
      publish: 'Publiser'
    },
    step1: {
      title: 'Velg menyelementer',
      subtitleSingle: 'Velg 1 menyelement å fremheve',
      subtitleCombo: 'Velg 2 elementer for kombotilbudet ditt',
      subtitleWeekly: 'Tilordne en rett til hver dag i uken',
      itemsSelected: '{count} av {max} elementer valgt',
      noItems: 'Ingen menyelementer tilgjengelig',
      uploadTitle: 'Last opp ditt eget bilde',
      uploadButton: 'Last opp bilde',
      uploadHint: 'JPG, PNG eller WebP',
      orDivider: 'ELLER velg fra menyen'
    },
    postType: {
      title: 'Hva slags innlegg vil du lage?',
      single: {
        title: 'Enkelt element',
        description: 'Fremhev én rett med et fokusert bilde'
      },
      combo: {
        title: 'Komboinnlegg',
        description: 'Vis frem 2 elementer som et spesialtilbud eller pakke'
      },
      weekly: {
        title: 'Ukemeny',
        description: 'Lag en meny med retter for hver dag'
      },
      weekLengthLabel: 'Hvor mange dager?',
      fiveDays: '5 dager (man-fre)',
      sevenDays: '7 dager (man-søn)',
      includePrices: 'Inkluder priser i bildet',
      assignDishes: 'Tilordne en rett til hver dag',
      selectDish: 'Velg rett...',
      selectDishFor: 'Velg rett for {day}',
      enterPrice: 'Skriv inn pris',
      of: 'av',
      dishesSelected: 'retter valgt',
      days: {
        monday: 'Mandag',
        tuesday: 'Tirsdag',
        wednesday: 'Onsdag',
        thursday: 'Torsdag',
        friday: 'Fredag',
        saturday: 'Lørdag',
        sunday: 'Søndag'
      }
    },
    step2: {
      title: 'Tilpass designet ditt',
      subtitle: 'Skreddersy utseendet til innlegget ditt',
      logoPositionLabel: 'Merke-logoposisjon',
      logoPositionHint: 'Hvor merkelogoen skal plasseres',
      previewLabel: 'Forhåndsvisning'
    },
    logoPositions: {
      topLeft: 'Topp venstre',
      topRight: 'Topp høyre',
      bottomLeft: 'Bunn venstre',
      bottomRight: 'Bunn høyre',
      center: 'Senter',
      none: 'Ingen logo'
    },
    fonts: {
      playfair: 'Playfair Display (Elegant)',
      inter: 'Inter (Moderne)',
      montserrat: 'Montserrat (Fet)',
      lora: 'Lora (Klassisk)',
      roboto: 'Roboto (Ren)'
    },
    step3: {
      title: 'Velg din stil',
      subtitle: 'Velg fra AI-genererte stilvarianter',
      generatingTitle: 'Utformer dine stiler',
      generatingSubtitle: 'Vår AI lager unike designalternativer for deg',
      selectStyle: 'Velg en stil for å fortsette',
      selectedStyle: 'Valgt stil',
      editPrompt: 'Rediger ledetekst',
      promptLabel: 'AI-ledetekst (redigerbar)',
      promptPlaceholder: 'Beskriv hvordan du vil at bildet ditt skal se ut...',
      regenerate: 'Regenerer stiler',
      outOfCredits: 'Du har ikke flere kreditter. Vennligst oppgrader planen din for å generere mer innhold.'
    },
    styleVariations: {
    },
    strictness: {
      label: 'Bildestil',
      hint: 'Hvor nært bør resultatet matche originalen?',
      strict: 'Streng',
      strictDesc: 'Hold deg til originalen - kun bedre anretning og lyssetting',
      flexible: 'Fleksibel',
      flexibleDesc: 'Hevet presentasjon med kreative detaljer',
      creative: 'Kreativ',
      creativeDesc: 'Kunstnerisk nytenkning med tilbehør og garnityr'
    },
    holidayTheme: {
      label: 'Tema / Inspirasjon',
      hint: 'Legg til en sesongbasert eller tematisk stil til bildet',
      customPlaceholder: 'Skriv inn ditt egendefinerte tema...'
    },
    comboOptions: {
      textPlacement: 'Tekstplassering',
      textPlacementHint: 'Hvor komboteksten vises',
      top: 'Topp overlay',
      bottom: 'Bunn overlay',
      side: 'Sidepanel',
      noText: 'Ingen tekst',
      itemArrangement: 'Elementarrangering',
      itemArrangementHint: 'Hvordan elementer vises sammen',
      sideBySide: 'Side om side',
      stacked: 'Stablet',
      overlapping: 'Overlappende',
      diagonal: 'Diagonal'
    },
    preview: {
      title: 'Forhåndsvisning',
      placeholder: 'Forhåndsvisning av innlegget vises her'
    },
    step4: {
      title: 'Forhåndsvis innlegget ditt',
      subtitle: 'Gjennomgå og rediger det genererte innholdet',
      editPostText: 'Rediger innleggsteksten din',
      addHashtagPlaceholder: 'Skriv hashtag og trykk Enter',
      nextButton: 'Fortsett til publisering'
    },
    step5: {
      title: 'Publiser',
      subtitle: 'Forhåndsvis innlegget ditt og publiser til sosiale medier',
      imagePreview: 'Bildeforhåndsvisning',
      postTextLabel: 'Innleggstekst',
      postTextPlaceholder: 'Skriv bildeteksten din...',
      hashtagsLabel: 'Emneknagger',
      addHashtag: 'Legg til emneknagg...'
    },
    publish: {
      publishingTitle: 'Deler innlegget ditt',
      publishingSubtitle: 'Laster opp til dine sosiale kontoer',
      error: 'Kunne ikke publisere. Prøv igjen.',
      retrying: 'Prøver igjen ({attempt}/{max})...',
      retryFailedPlatforms: 'Prøv mislykkede plattformer på nytt'
    },
    navigation: {
      back: '← Tilbake',
      next: 'Neste →',
      generate: 'Generer →'
    },
    messages: {
      styleRequired: 'Velg en stilvariant',
      generationError: 'Kunne ikke generere. Prøv igjen.',
      captionGenerationFailed: 'Kunne ikke generere bildetekst',
      imageGenerationFailed: 'Kunne ikke generere bilde',
      unexpectedError: 'En uventet feil oppstod. Prøv igjen.'
    }
  },

  // Ukemeny tilpasningsalternativer
  weeklyCustomization: {
    layout: {
      title: 'Menylayout',
      featuredGrid: 'Fremhevet + Rutenett',
      featuredGridDesc: '1 stor fremhevet rett + 2x2 rutenett',
      calendarGrid: 'Kalenderstil',
      calendarGridDesc: '5 kolonner rutenett',
      verticalStack: 'Vertikal liste',
      verticalStackDesc: '5 retter stablet ovenfra og ned',
      gridWithHeader: '2x3 Rutenett',
      gridWithHeaderDesc: '2x3 rutenett med tittel'
    },
    dates: {
      title: 'Datovisning',
      showDates: 'Vis datoer på menyen',
      formatFull: 'Full (2.-6. desember)',
      formatShort: 'Kort (2.-6. des)',
      formatDayOnly: 'Kun dagnavn',
      showWeekNumber: 'Vis ukenummer',
      showMonthName: 'Vis månedsnavn',
      dateRange: 'Egendefinert datoperiode'
    },
    themes: {
      title: 'Menytema',
      none: 'Ingen tema',
      studentWeek: 'Studentuke',
      christmas: 'Juleferie',
      easter: 'Påskespesial',
      summer: 'Sommermeny',
      valentines: 'Valentinsdag',
      halloween: 'Halloween',
      thanksgiving: 'Thanksgiving',
      newYear: 'Nyttår',
      custom: 'Egendefinert tekst',
      customPlaceholder: 'Skriv inn din egendefinerte tematekst...'
    }
  },

  // Connect Accounts View
  connectAccounts: {
    pageTitle: 'Koble sosiale mediekontoer',
    pageSubtitle: 'Koble til dine sosiale mediekontoer for å publisere innhold direkte fra plattformen vår',
    activeBusiness: 'Aktivt merke',
    switchBusiness: 'Bytt merke',
    manageAll: 'Administrer alle',
    selectABusiness: 'Velg et merke',
    noBusinessSelected: 'Ingen merke valgt',
    selectBusinessFirst: 'Vennligst velg et merke først',
    businessCount: '{current} av {total}',
    totalConnections: 'Totale tilkoblinger',
    facebookPages: 'Facebook-sider',
    facebookPagesCount: 'Facebook-sider',
    instagramBusiness: 'Instagram Business',
    instagramAccountsCount: 'Instagram-kontoer',
    connectedPlatforms: 'Tilkoblede plattformer',
    platformsFor: 'Administrer plattformtilkoblinger for {name}',
    chooseBusiness: 'Velg et merke for å administrere tilkoblinger',
    notConnected: 'Ikke tilkoblet',
    connect: 'Koble til',
    connectMore: 'Koble til flere',
    disconnect: 'Koble fra',
    disconnectAll: 'Koble fra alle',
    connecting: 'Kobler til...',
    comingSoon: 'Kommer snart',
    accountsConnected: '{count} konto tilkoblet | {count} kontoer tilkoblet',
    errorOccurred: 'En feil oppstod. Vennligst prøv igjen.',
    successfullyConnected: 'Koblet til {count} konto(er)!',
    successfullyConnectedFacebook: 'Koblet til {count} Facebook-side(r)!',
    successfullyConnectedInstagram: 'Koblet til {count} Instagram-konto(er)!',
    successfullyConnectedTikTok: 'Koblet til {count} TikTok-konto(er)!',
    successfullyConnectedTwitter: 'Koblet til {count} Twitter-konto(er)!',
    successfullyConnectedLinkedIn: 'Koblet til {count} LinkedIn-side(r)!',
    successfullyDisconnected: 'Frakoblet "{name}"',
    successfullyDisconnectedAll: 'Frakoblet {count} kontoer',
    confirmDisconnect: 'Er du sikker på at du vil frakoble "{name}"?',
    confirmDisconnectAll: 'Er du sikker på at du vil frakoble alle {count} {platform} kontoer?',
    disconnectTitle: 'Frakoble konto',
    disconnectAllTitle: 'Frakoble alle kontoer'
  },

  // Scheduler View
  scheduler: {
    title: 'Innholdsplanlegger',
    subtitle: 'Planlegg og administrer innleggene dine for sosiale medier',
    scheduledPosts: 'Planlagte innlegg',
    postScheduled: 'Innlegg planlagt!',
    createPost: 'Lag innlegg',
    moreHolidays: 'flere',
    postDetails: 'Innleggsdetaljer',
    publishedAt: 'Publisert',
    viewPost: 'Se innlegg',
    viewOn: 'Se på',
    restaurant: 'Merke',
    caption: 'Bildetekst',
    edit: 'Rediger',
    cancelPost: 'Avbryt innlegg',
    noTime: 'Ingen tid',
    noMedia: 'Ingen media',
    post: 'Innlegg',
    status: 'Status',
    publishTime: 'Publiseringstid',
    captionGenerationFailed: 'Kunne ikke generere bildetekst',
    imageGenerationFailed: 'Kunne ikke generere bilde',
    generationFailed: 'Generering mislyktes',
    unexpectedError: 'En uventet feil oppstod. Prøv igjen.',
    retryPost: 'Prøv på nytt',
    retrying: 'Prøver på nytt...',
    retrySuccess: 'Innlegget er satt i kø for nytt forsøk',
    retryError: 'Kunne ikke prøve innlegget på nytt',
    partial: 'Delvis publisert',
    overdue: 'Forsinket'
  },

  // Edit Scheduled Post Modal
  editScheduledPost: {
    title: 'Rediger planlagt innlegg',
    changeImage: 'Bytt bilde',
    selectImage: 'Velg et annet bilde',
    postTextPlaceholder: 'Skriv innleggsinnholdet ditt her...',
    hashtagPlaceholder: 'Legg til hashtag og trykk Enter...',
    notConnected: 'Ikke tilkoblet',
    selectPlatform: 'Vennligst velg minst én plattform',
    detected: 'Oppdaget',
    notes: 'Notater (valgfritt)',
    notesPlaceholder: 'Legg til notater om dette innlegget...',
    characters: 'tegn'
  },

  // Posts View (previously Favorites)
  posts: {
    editPost: 'Rediger innlegg',
    postText: 'Innleggstekst',
    hashtags: 'Hashtags',
    image: 'bilde',
    video: 'video',
    // Additional post actions
    deleteModalTitle: 'Slett innlegg',
    deleteModalMessage: 'Er du sikker på at du vil slette dette innlegget? Denne handlingen kan ikke angres.',
    addHashtagPlaceholder: 'Legg til hashtag og trykk Enter...',
    platformSection: 'Plattform',
    saveChangesButton: 'Lagre endringer',
    cancelChangesButton: 'Avbryt',
    publishButton: 'Publiser',
    postAlt: 'Innlegg',
    // Background video generation
    videoGenerationStarted: 'Videogenerering startet',
    videoGeneratingInBackground: 'Videoen din genereres i bakgrunnen. Du kan poste bildet nå eller vente på videoen.',
    videoReady: 'Video klar',
    videoReadyToView: 'Video for "{title}" er klar til visning',
    videoGenerationFailed: 'Videogenerering mislyktes',
    create: {
      captionGenerationFailed: 'Kunne ikke generere bildetekst',
      imageGenerationFailed: 'Kunne ikke generere bilde',
      videoGenerationFailed: 'Kunne ikke generere video',
      generationFailed: 'Generering mislyktes',
      unexpectedError: 'En uventet feil oppstod. Prøv igjen.',
      animationFailed: 'Animering mislyktes',
      animationSuccess: 'Animering fullført',
      videoGenerated: 'Video har blitt generert'
    }
  },

  // Content Hub View
  contentHub: {
    loading: 'Laster innholdet ditt...',
    yourPosts: 'Dine innlegg',
    noPosts: 'Ingen innlegg ennå',
    noPostsDescription: 'Lag ditt første innlegg for å komme i gang!',
    filterAll: 'Alle',
    sortNewest: 'Nyeste først',
    sortOldest: 'Eldste først',
    // Welcome state for new users
    welcomeTitle: 'Velkommen!',
    welcomeSubtitle: 'La oss starte med å legge til ditt første merke.',
    addFirstRestaurant: 'Legg til ditt første merke',
    addFirstRestaurantDescription: 'Legg til merket ditt og vi hjelper deg med å lage fantastisk innhold for sosiale medier.',
    noRestaurantPrompt: 'Legg til et merke for å begynne å lage innlegg.',
    addFirstBusiness: 'Legg til ditt første merke',
    addFirstBusinessDescription: 'Legg til merket ditt og vi hjelper deg med å lage fantastisk innhold for sosiale medier.',
    manageBusinesses: 'Administrer merker',
    createPost: 'Lag innlegg'
  },

  // Content Create View
  contentCreate: {
    loading: 'Laster...',
    loadError: 'Kunne ikke laste merke',
    switchRestaurant: 'Bytt',
    imageError: 'Kunne ikke generere bilde. Prøv igjen.',
    videoError: 'Kunne ikke generere video. Prøv igjen.',
    videoTimeout: 'Videogenerering tok for lang tid. Prøv igjen.',
    noPrompts: 'Ingen ledetekster ble generert',
    generateError: 'Kunne ikke generere innhold',
    publishError: 'Kunne ikke publisere til Facebook',
    noFacebookPage: 'Ingen Facebook-side tilkoblet',
    facebookReconnectRequired: 'Facebook-tilkoblingen din har utløpt. Koble til på nytt for å fortsette.',
    noPlatformSelected: 'Vennligst velg minst én plattform',
    carouselMode: 'Karusell-modus',
    singleImageMode: 'Enkelt bilde',
    selectCarouselImages: 'Velg 2-10 bilder',
    imageCount: '{current} av {max} bilder',
    minImagesRequired: 'Velg minst 2 bilder for karusell',
    maxImagesExceeded: 'Maksimalt 10 bilder tillatt',
    reorderHint: 'Dra bilder for å endre rekkefølge',
    uploadImages: 'Last opp bilder',
    dropOrClick: 'Slipp bilder her eller klikk for å velge',
    removeImage: 'Fjern bilde',
    fromLibrary: 'Fra bibliotek',
    uploadNew: 'Last opp ny',
    selectFromLibrary: 'Velg fra bibliotek',
    librarySubtitle: 'Velg 2-10 bilder eller videoer fra dine lagrede innlegg',
    selectedOrder: 'Valgt rekkefølge (dra for å endre)',
    noSavedMedia: 'Ingen lagrede innlegg funnet',
    createPostsFirst: 'Opprett noen innlegg først for å bruke dem i karuseller',
    selectMoreItems: 'Velg {count} til for å fortsette',
    uploadInstructions: 'Last opp 2-10 nye bilder for karusellen din',
    uploadFeatureComingSoon: 'Direkte opplasting kommer snart. Bruk bibliotek-fanen for å velge fra eksisterende innlegg.'
  },

  // Restaurant Selector Modal
  restaurantSelector: {
    title: 'Velg merke',
    addNew: '+ Legg til nytt merke',
    menuItems: '{count} menyelementer',
    delete: 'Fjern merke',
    deleteTitle: 'Fjern merke',
    confirmDelete: 'Er du sikker på at du vil fjerne "{name}" fra dine lagrede merker?',
    restaurantAdded: 'Merke lagt til!',
    cantFindAddManually: 'Finner du ikke merket ditt? Legg til manuelt'
  },

  // Image Source Selector
  imageSourceSelector: {
    uploadNew: 'Last opp ny',
    browseExisting: 'Bla gjennom eksisterende',
    selectImage: 'Velg et bilde',
    noImagesAvailable: 'Ingen bilder tilgjengelig',
    folderEmpty: 'Denne mappen er tom',
    searchPlaceholder: 'Søk bilder...',
    selectFromStorage: 'Velg fra dine merkebilder',
    uploadOrSelect: 'Last opp et nytt bilde eller velg fra dine eksisterende bilder'
  },

  // Profile View
  profile: {
    title: 'Profilinnstillinger',
    subtitleExtended: 'Administrer kontoinformasjonen og abonnementet ditt',
    personalInfo: 'Personlig informasjon',
    manageRestaurants: 'Administrer merker',
    email: 'E-post',
    emailAddress: 'E-postadresse',
    userId: 'Bruker-ID',
    saving: 'Lagrer...',
    saveChanges: 'Lagre endringer',
    profileUpdated: 'Profil oppdatert!',
    deleteAccount: 'Slett konto',
    edit: 'Rediger',
    cancel: 'Avbryt',
    subscriptionAndPlan: 'Abonnement og plan',
    viewPlans: 'Vis planer',
    monthlyCredits: 'Månedlige poeng',
    creditsUsedThisMonth: 'Poeng brukt denne måneden',
    remainingCredits: 'Gjenværende poeng',
    subscriptionEnds: 'Abonnement utløper',
    nextBillingDate: 'Neste faktureringsdato',
    cancelNotice: 'Abonnementet ditt vil bli kansellert ved slutten av den nåværende faktureringsperioden.',
    upgradePlan: 'Oppgrader plan',
    cancelSubscription: 'Kanseller abonnement',
    billingInformation: 'Faktureringsinformasjon',
    billingDescription: 'Fakturering administreres gjennom Stripe. Klikk nedenfor for å administrere betalingsmetodene dine, se fakturaer og oppdatere faktureringsinformasjon.',
    manageBilling: 'Administrer fakturering',
    loading: 'Laster...',
    accountSecurity: 'Kontosikkerhet',
    deleteAccountDanger: 'Slett konto',
    deleteAccountDescription: 'Slett kontoen din og alle data permanent',
    cancelSubscriptionTitle: 'Kanseller abonnement',
    cancelSubscriptionMessage: 'Er du sikker på at du vil kansellere abonnementet ditt? Du vil fortsatt ha tilgang til slutten av den nåværende faktureringsperioden.',
    keepSubscription: 'Behold abonnement',
    failedToOpenPortal: 'Kunne ikke åpne faktureringsportalen',
    failedToCancelSubscription: 'Kunne ikke kansellere abonnement',
    failedToUpdateProfile: 'Kunne ikke oppdatere profil',
    notificationPreferences: 'E-postvarsler',
    notifications: {
      saveSuccess: 'Varslingsinnstillinger lagret',
      saveError: 'Kunne ikke lagre varslingsinnstillinger',

      postEvents: {
        title: 'Innleggsaktivitet',
        description: 'Få varsler når innleggene dine publiseres, feiler eller planlegges',
        published: 'Innlegg publisert',
        publishedHint: 'Motta en e-post når innlegget ditt er publisert på en plattform',
        failed: 'Innlegg mislyktes',
        failedHint: 'Få varsler umiddelbart hvis et innlegg ikke blir publisert',
        scheduled: 'Innlegg planlagt',
        scheduledHint: 'Bekreftelse e-post når du planlegger et innlegg'
      },

      digest: {
        title: 'Aktivitetssammendrag',
        description: 'Motta periodiske sammendrag av din publiseringsaktivitet',
        frequency: 'Frekvens',
        never: 'Aldri',
        daily: 'Daglig',
        weekly: 'Ukentlig',
        monthly: 'Månedlig',
        dayOfWeek: 'Send på',
        days: {
          sunday: 'Søndag',
          monday: 'Mandag',
          tuesday: 'Tirsdag',
          wednesday: 'Onsdag',
          thursday: 'Torsdag',
          friday: 'Fredag',
          saturday: 'Lørdag'
        }
      },

      account: {
        title: 'Konto og fakturering',
        description: 'Viktige oppdateringer om abonnement og betalinger',
        subscription: 'Abonnementsendringer',
        subscriptionHint: 'Fornyelser, kanselleringer og planendringer',
        payment: 'Betalingsproblemer',
        paymentHint: 'Mislykkede betalinger og faktureringsproblemer',
        creditsLow: 'Lave kreditter',
        creditsLowHint: 'Varsling når du begynner å gå tom for kreditter'
      },

      product: {
        title: 'Produktoppdateringer',
        description: 'Hold deg informert om nye funksjoner og kunngjøringer',
        features: 'Nye funksjoner',
        featuresHint: 'Lær om nye muligheter og forbedringer',
        announcements: 'Bedriftsnyheter',
        announcementsHint: 'Sporadiske oppdateringer fra Social Chef-teamet'
      }
    }
  },

  // Restaurant Management
  restaurantManagement: {
    addRestaurant: 'Legg til merke',
    addFirstRestaurant: 'Legg til ditt første merke',
    createRestaurant: 'Opprett merke',
    uploadImages: 'Last opp bilder',
    yourImages: 'Dine bilder',

    noRestaurants: 'Ingen merker ennå',
    noRestaurantsHint: 'Legg til ditt første merke for å komme i gang',
    noBrandsHint: 'Legg til ditt første merke for å komme i gang',

    basicInfo: 'Grunnleggende informasjon',
    contactInfo: 'Kontaktinformasjon',
    socialMedia: 'Sosiale medier',
    branding: 'Merkevare',

    restaurantName: 'Merkenavn',
    restaurantNamePlaceholder: 'f.eks., Mitt Merke',
    address: 'Adresse',
    addressPlaceholder: 'Skriv inn full adresse',
    phoneNumber: 'Telefonnummer',
    phoneNumberPlaceholder: '+47 123 45 678',
    website: 'Nettside',
    websitePlaceholder: 'https://dittmerke.no',

    instagram: 'Instagram',
    instagramPlaceholder: "{'@'}dittmerke",
    facebook: 'Facebook',
    facebookPlaceholder: 'facebook.com/dittmerke',
    twitter: 'Twitter/X',
    twitterPlaceholder: "{'@'}dittmerke",

    logoUrl: 'Logo-URL',
    logoUrlPlaceholder: 'https://...',
    logoUrlHint: 'Skriv inn en URL til merkets logo',
    logo: 'Logo',
    dragLogoOrClick: 'Dra og slipp logo her eller klikk for å velge',
    logoMaxSize: 'Maksimum {size}MB (JPEG, PNG, WebP)',
    logoPreview: 'Logoforhåndsvisning',
    primaryColor: 'Primærfarge for merkevare',
    secondaryColor: 'Sekundærfarge for merkevare',

    manualEntry: 'Manuell',
    googlePlaces: 'Google Places',
    imagesCount: '{count} bilder',

    details: 'Detaljer',
    images: 'Bilder',
    noImages: 'Ingen bilder lastet opp ennå',

    deleteConfirmMessage: 'Slette "{name}"? Dette kan ikke angres.',
    deleteImageConfirm: 'Er du sikker på at du vil slette dette bildet?',

    // Folder Navigation
    folderTree: 'Mapper',
    allImages: 'Alle bilder',
    createFolder: 'Opprett mappe',
    renameFolder: 'Gi nytt navn til mappe',
    deleteFolder: 'Slett mappe',
    deleteImages: 'Slett bilder',
    folderName: 'Mappenavn',
    folderNamePlaceholder: 'f.eks., meny, burgere, desserter',
    newFolder: 'Ny mappe',
    rename: 'Gi nytt navn',
    delete: 'Slett',

    // Folder Path
    createIn: 'Opprett i',
    fullPath: 'Full sti',
    currentPath: 'Nåværende sti',
    newPath: 'Ny sti',

    // Breadcrumbs & Navigation
    breadcrumbHome: 'Alle bilder',

    // View Modes
    viewMode: 'Visning',
    gridView: 'Rutenett',
    listView: 'Liste',
    timelineView: 'Tidslinje',

    // Toolbar
    searchImages: 'Søk i bilder...',
    searchPlaceholder: 'Søk etter navn eller mappe...',
    sortBy: 'Sorter etter',
    sortByName: 'Navn',
    sortByDate: 'Opplastingsdato',
    sortBySize: 'Filstørrelse',

    // Bulk Actions
    selectAll: 'Velg alle',
    deselectAll: 'Fjern alle valg',
    selectedCount: '{count} valgt',
    deleteSelected: 'Slett valgte',
    moveSelected: 'Flytt til mappe',
    downloadSelected: 'Last ned valgte',
    bulkDeleteConfirm: 'Slette {count} valgte bilder? Dette kan ikke angres.',
    bulkDeleteSuccess: '{count} bilder slettet',

    // Move Images
    moveImages: 'Flytt {count} bilder',
    moveImagesInfo: 'Velg en destinasjonsmappe for {count} valgte bilder',
    selectDestination: 'Velg destinasjonsmappe',
    movingTo: 'Flytter til',
    moveCount: 'Flytt {count} bilder',

    // Upload & Folder Actions
    uploadToFolder: 'Last opp til mappe',
    selectFolder: 'Velg mappe',
    selectDestinationFolder: 'Velg destinasjonsmappe',
    currentFolder: 'Nåværende mappe',
    newFolderName: 'Nytt mappenavn',
    enterFolderName: 'Skriv inn mappenavn',
    createNewFolder: 'Opprett ny mappe',
    moveToFolder: 'Flytt til mappe',
    dragDropHint: 'Dra og slipp bilder her, eller klikk for å bla gjennom',
    maxFilesHint: 'Maksimalt {max} filer per opplasting',
    uploadingImages: 'Laster opp bilder...',
    uploadSuccess: '{count} bilder lastet opp',
    folderCreated: 'Mappe "{name}" opprettet',
    newFolderReady: 'Ny mappe "{name}" klar - vil bli opprettet når du laster opp',
    folderRenamed: 'Mappe gitt nytt navn',
    folderDeleted: 'Mappe slettet',
    deleteFolderConfirm: 'Slette mappe "{name}" og alt innhold? Dette kan ikke angres.',

    // Empty States
    noImagesInFolder: 'Ingen bilder i denne mappen',
    noImagesFound: 'Ingen bilder funnet som matcher "{query}"',
    createFolderFirst: 'Opprett en mappe først for å organisere bildene dine',

    // Folder Errors
    folderNameRequired: 'Mappenavn er påkrevd',
    folderNameUnchanged: 'Vennligst skriv inn et annet mappenavn',
    chooseFolderPlaceholder: 'Velg en mappe...',
    invalidFolderName: 'Ugyldig mappenavn. Unngå spesialtegn som / \\ : * ? " < > |',
    createFolderError: 'Kunne ikke opprette mappe',
    renameFolderError: 'Kunne ikke gi nytt navn til mappe',
    moveImagesError: 'Kunne ikke flytte bilder',
    selectFolderError: 'Vennligst velg en destinasjonsmappe',

    errors: {
      createFailed: 'Kunne ikke opprette merke',
      uploadFailed: 'Kunne ikke laste opp bilder',
      folderExists: 'En mappe med dette navnet finnes allerede',
      invalidFolderName: 'Ugyldig mappenavn',
      noFilesSelected: 'Vennligst velg filer å laste opp',
      selectFolderRequired: 'Vennligst velg en mappe',
      tooManyFiles: 'For mange filer valgt ({count}). Maksimalt {max} filer tillatt per opplasting.',
      folderNotEmpty: 'Mappen er ikke tom',
      onlyImages: 'Bare bildefiler er tillatt',
      logoTooLarge: 'Logofilen må være mindre enn {size}MB',
      logoUploadFailed: 'Kunne ikke laste opp logo'
    }
  },

  // Saved Restaurants View

  // Test Post View

  // Errors
  errors: {
    generic: 'Noe gikk galt',
    networkError: 'Nettverksfeil. Vennligst sjekk tilkoblingen din.',
    validationError: 'Vennligst sjekk inndata',
    timeout: 'Forespørsel tidsavbrutt. Vennligst prøv igjen.',
    httpError: 'Serverfeil: {status}',
    publishPartial: 'Publisert til {success} av {total} plattformer',
    retryFailed: 'Nytt forsøk mislyktes etter {attempts} forsøk',
    postSavedScheduleFailed: 'Innlegg lagret, men planlegging mislyktes',
    postSavedScheduleFailedMessage: 'Innlegget ditt ble lagret i Favoritter. Du kan planlegge det senere fra Innlegg-siden.'
  },

  // Alerts & Toasts
  alerts: {
  },

  // Form Validation

  // Languages
  languages: {
    selectCountry: 'Land',
    selectCurrency: 'Valuta (Dev)',
  },

  // Schedule Modal
  scheduleModal: {
    title: 'Publiser innlegg',
    preview: 'Forhåndsvisning',
    dateLabel: 'Dato',
    timeLabel: 'Tid (Valgfritt)',
    timezoneLabel: 'Tidssone',
    notesLabel: 'Notater (Valgfritt)',
    notesPlaceholder: 'Legg til notater om dette planlagte innlegget...'
  },

  // Pick Post Modal
  pickPostModal: {
    showAllRestaurants: 'Vis alle merker',
    showCurrentRestaurant: 'Vis kun valgt merke',
    allRestaurantsLabel: 'Alle merker',
    videoLabel: 'VIDEO'
  },

  // Account Selector
  accountSelector: {
    selectAccounts: 'Velg kontoer',
    selectFacebookPages: 'Velg Facebook-sider',
    selectInstagramAccounts: 'Velg Instagram-kontoer',
    selectTikTokAccounts: 'Velg TikTok-kontoer',
    selectTwitterAccounts: 'Velg Twitter-kontoer',
    noAccountsConnected: 'Ingen {platform}-kontoer tilkoblet',
    noAccountsSelected: 'Vennligst velg minst én {platform}-konto',
    connectAccount: 'Koble til konto',
    multipleSelected: '{count} kontoer valgt',
    accountId: 'Konto-ID',
    singleAccountInfo: 'Dette er din eneste tilkoblede konto. Den vil bli brukt til å publisere.',
    postTypeLabel: 'Innleggstype',
    reelsRequireVideo: 'Reels krever videoinnhold',
    feedShort: 'Hoved-feed',
    feedDescription: 'Vises i følgeres feeder og på profilen din. Permanent innhold med fulle engasjementsfunksjoner.',
    storyShort: '24t midlertidig',
    storyDescription: 'Forsvinner etter 24 timer. Fullskjerm vertikalt format med interaktive klistremerker og avstemninger.',
    reelShort: 'Kort video',
    reelDescription: 'Kort videoinnhold (15-90s). Optimalisert for oppdagelse og engasjement. Krever videoinnhold.',
    carouselShort: '2-10 elementer',
    carouselDescription: 'Klikk for å velge 2-10 bilder eller videoer i sveipbart format',
    carouselRequiresImages: 'Velg 2-10 bilder for å aktivere karusell',
    carouselItemsSelected: '{count} elementer',
    carouselModalTitle: 'Velg karusellelementer',
    carouselModalSubtitle: 'Velg 2-10 elementer og dra for å endre rekkefølge'
  },

  // Unified Schedule Post
  unifiedSchedule: {
    whenToPublish: 'Når skal du publisere',
    publishNow: 'Publiser nå',
    scheduleLater: 'Planlegg for senere',
    selectPlatforms: 'Velg plattformer',
    selectDate: 'Velg dato',
    selectTime: 'Velg tid',
    tapToConnect: 'Trykk for å koble til',
    comingSoon: 'Kommer snart',
    publish: 'Publiser',
    schedule: 'Planlegg innlegg',
    noPlatformSelected: 'Vennligst velg minst én plattform',
    noDateSelected: 'Vennligst velg en dato',
    mustBeInFuture: 'Planlagt tid må være etter nå',
    selectAccountsInfo: 'Velg hvilke kontoer du vil publisere til',
    publishSummary: 'Hvor innholdet ditt vil bli publisert',
    clickToSelectAccounts: 'Klikk for å velge kontoer'
  },

  // Mode Toggle
  modeToggle: {
    easy: 'Enkel',
    advanced: 'Avansert',
    easyTitle: 'Enkel modus - Rask innleggsoppretting',
    advancedTitle: 'Avansert modus - Full tilpasning',
    confirmTitle: 'Bytte modus?',
    confirmMessage: 'Du har ulagret arbeid. Å bytte modus vil forkaste din nåværende fremdrift.',
    switchAnyway: 'Bytt likevel'
  },

  // Confirm Modal

  // Pick Post Modal

  // Generation Result Modal

  // Publishing Progress Modal
  publishing: {
    title: 'Publiserer innlegget ditt...',
    titleWithType: 'Publiserer {type}...',
    message: 'Vennligst vent mens vi publiserer innlegget ditt til de valgte plattformene.',
    messageWithType: 'Vennligst vent mens vi publiserer {type} til de valgte plattformene.',
    publishingTo: 'Publiserer til {platform}...',
    publishingTypeTo: 'Publiserer {type} til {platform}...',
    successTitle: 'Gratulerer!',
    successMessage: 'Innlegget ditt har blitt publisert!',
    successMessageWithType: '{type} har blitt publisert!',
    partialSuccessTitle: 'Delvis publisert',
    errorTitle: 'Publisering mislyktes',
    errorMessage: 'Kunne ikke publisere til noen plattform.',
    createAnother: 'Lag et nytt innlegg'
  },

  // Carousel Content
  carousel: {
    generateContentTitle: 'Tilpass karusellinnhold',
    generating: 'Genererer innhold...',
    selectedImages: 'Valgte bilder',
    caption: 'Bildetekst',
    captionPlaceholder: 'Skriv bildeteksten for karusellen...',
    hashtags: 'Hashtags (en per linje)',
    hashtagsPlaceholder: '#mat\n#merke\n#deilig',
    hashtagsHint: 'Skriv en hashtag per linje',
    regenerate: 'Generer innhold på nytt',
    useContent: 'Bruk dette innholdet',
    wizardTitle: 'Lag karusellinnlegg',
    step1Title: 'Velg bilder',
    step2Title: 'Tilpass innhold',
    nextStep: 'Neste',
    previousStep: 'Tilbake'
  },

  // Sidebar Navigation
  sidebar: {
    menu: 'Meny',
    dashboard: 'Dashbord',
    content: 'Innlegg',
    calendar: 'Tidsplan',
    analytics: 'Analyse',
    platforms: 'Plattformer',
    creditsUsed: 'Poeng brukt',
    upgrade: 'Oppgrader',
    profile: 'Profil',
    logout: 'Logg ut',
    notifications: 'Varsler',
    referFriend: 'Verv en venn',
    unlimited: 'Ubegrenset',
    unlimitedCredits: 'Ubegrenset'
  },

  // New Dashboard Elements
  dashboardNew: {
    settings: 'Innstillinger',
    recentPosts: 'Nylige innlegg',
    viewAll: 'Se alle',
    viewCalendar: 'Se kalender',
    manageSaved: 'Administrer lagrede',
    openSettings: 'Åpne innstillinger',
    noRecentPosts: 'Ingen innlegg ennå',
    createFirstPost: 'Lag ditt første innlegg',
    post: 'Innlegg',
    status: 'Status',
    platforms: 'Plattformer',
    activeCount: 'Aktive',
    allRestaurants: 'Alle merker',
    restaurant: 'Merke',
    published: 'Publisert',
    scheduled: 'Planlagt',
    failed: 'Mislykket',
    partial: 'Delvis publisert',
    cancelled: 'Avbrutt',
    draft: 'Utkast',
    creditsLeft: 'kreditter igjen',
    tierLifetimeDesc: 'Ubegrenset tilgang for alltid',
    tierYearlyDesc: 'Best verdi, fakturert årlig',
    tierMonthlyDesc: 'Fleksibel månedlig fakturering'
  },

  // Dashboard Redesign
  dashboardRedesign: {
    goodMorning: 'God morgen, {name}',
    goodAfternoon: 'God ettermiddag, {name}',
    goodEvening: 'God kveld, {name}',
    heroSubtitle: 'Her er hva som skjer med innholdet ditt i dag',
    createContent: 'Lag innhold',
    totalPosts: 'Totalt innlegg',
    scheduledLabel: 'Planlagt',
    savedContent: 'Lagret innhold',
    creditsLabel: 'Kreditter igjen',
    untitledPost: 'Uten tittel',
    today: 'I dag',
    tomorrow: 'I morgen',
    engagementSnapshot: 'Engasjementsoversikt',
    viewAnalytics: 'Se analyse',
    upcomingPosts: 'Kommende innlegg',
    viewCalendar: 'Se kalender',
    noUpcomingTitle: 'Ingen kommende innlegg',
    noUpcomingDesc: 'Planlegg ditt første innlegg for å se det her',
    scheduleFirst: 'Planlegg et innlegg',
    recentActivity: 'Nylig aktivitet',
    viewAllPosts: 'Se alle innlegg',
    noActivityTitle: 'Ingen nylig aktivitet',
    noActivityDesc: 'Lag ditt første innlegg for å komme i gang'
  },

  // Privacy Policy
  privacy: {
    title: 'Personvernerklæring',
    lastUpdated: 'Sist oppdatert: 5. desember 2025',
    sections: {
      introduction: {
        title: '1. Introduksjon',
        content: 'Velkommen til SocialChef ("vi", "vår" eller "oss"). Vi er forpliktet til å beskytte personvernet ditt og sikre sikkerheten til din personlige informasjon. Denne personvernerklæringen forklarer hvordan vi samler inn, bruker, deler og beskytter informasjonen din når du bruker vår AI-drevne plattform for sosiale medier.'
      },
      informationWeCollect: {
        title: '2. Informasjon vi samler inn',
        intro: 'Vi samler inn følgende typer informasjon:',
        items: {
          accountInfo: 'Kontoinformasjon: Navn, e-postadresse, passord og profildetaljer når du oppretter en konto.',
          socialMedia: 'Sosiale medier-data: Når du kobler til dine sosiale mediekontoer (Facebook, Instagram, osv.), får vi tilgang til dataene som er nødvendige for å publisere innhold på dine vegne, inkludert sideinformasjon og publiseringstillatelser.',
          content: 'Innholdsdata: Bilder, bildetekster, hashtags og annet innhold du oppretter eller laster opp gjennom plattformen vår.',
          usage: 'Bruksinformasjon: Hvordan du samhandler med plattformen vår, inkludert funksjoner som brukes, innlegg som opprettes og planleggingspreferanser.',
          device: 'Enhetsinformasjon: Nettlesertype, IP-adresse, enhetsidentifikatorer og operativsystem for sikkerhets- og analyseformål.'
        }
      },
      howWeUse: {
        title: '3. Hvordan vi bruker informasjonen din',
        intro: 'Vi bruker informasjonen din til å:',
        items: {
          provideService: 'Tilby og drive våre AI-drevne innholdsgenerings- og sosiale medieadministrasjonstjenester.',
          improveService: 'Forbedre og tilpasse opplevelsen din, inkludert opplæring av våre AI-modeller for å bedre betjene dine innholdsbehov.',
          communicate: 'Sende deg tjenesterelatert kommunikasjon, oppdateringer og markedsføringsmateriell (med ditt samtykke).',
          security: 'Sikre sikkerheten til plattformen vår og beskytte mot svindel eller uautorisert tilgang.',
          legal: 'Overholde juridiske forpliktelser og håndheve våre tjenestevilkår.'
        }
      },
      dataSharing: {
        title: '4. Datadeling og utlevering',
        intro: 'Vi kan dele informasjonen din med:',
        items: {
          socialPlatforms: 'Sosiale medieplattformer: For å publisere innhold på dine tilkoblede kontoer (Facebook, Instagram, osv.).',
          serviceProviders: 'Tjenesteleverandører: Tredjepartsleverandører som hjelper oss med å drive plattformen vår (hosting, analyse, betalingsbehandling).',
          legal: 'Juridiske krav: Når det kreves av lov, rettsordre eller myndighetspålegg.',
          businessTransfer: 'Virksomhetsoverdragelser: I forbindelse med fusjon, oppkjøp eller salg av eiendeler.'
        },
        noSelling: 'Vi selger ikke din personlige informasjon til tredjeparter.'
      },
      dataSecurity: {
        title: '5. Datasikkerhet',
        content: 'Vi implementerer bransjestandardens sikkerhetstiltak for å beskytte informasjonen din, inkludert kryptering, sikre servere og regelmessige sikkerhetsrevisjoner. Ingen overføringsmetode over Internett er imidlertid 100% sikker, og vi kan ikke garantere absolutt sikkerhet.'
      },
      dataRetention: {
        title: '6. Dataoppbevaring',
        content: 'Vi beholder din personlige informasjon så lenge kontoen din er aktiv eller etter behov for å gi deg tjenester. Du kan når som helst be om sletting av dataene dine ved å kontakte oss eller gjennom kontoinnstillingene dine.'
      },
      yourRights: {
        title: '7. Dine rettigheter',
        intro: 'Avhengig av hvor du befinner deg, kan du ha følgende rettigheter:',
        items: {
          access: 'Tilgang: Be om en kopi av den personlige informasjonen vi har om deg.',
          correction: 'Retting: Be om retting av unøyaktig eller ufullstendig informasjon.',
          deletion: 'Sletting: Be om sletting av din personlige informasjon.',
          portability: 'Dataportabilitet: Be om en kopi av dataene dine i et portabelt format.',
          withdraw: 'Trekke tilbake samtykke: Trekke tilbake samtykke til behandling der samtykke er det rettslige grunnlaget.'
        },
        contact: 'For å utøve disse rettighetene, vennligst kontakt oss på e-postadressen nedenfor.'
      },
      cookies: {
        title: '8. Informasjonskapsler og sporing',
        content: 'Vi bruker informasjonskapsler og lignende teknologier for å forbedre opplevelsen din, analysere bruk og tilpasse innhold. Du kan kontrollere informasjonskapselpreferanser gjennom nettleserinnstillingene dine. Noen funksjoner fungerer kanskje ikke riktig hvis informasjonskapsler er deaktivert.'
      },
      thirdParty: {
        title: '9. Tredjepartslenker',
        content: 'Plattformen vår kan inneholde lenker til tredjepartsnettsteder eller -tjenester. Vi er ikke ansvarlige for personvernpraksisen til disse eksterne nettstedene. Vi oppfordrer deg til å gjennomgå deres personvernerklæringer før du oppgir personlig informasjon.'
      },
      children: {
        title: '10. Barns personvern',
        content: 'Våre tjenester er ikke beregnet på personer under 18 år. Vi samler ikke bevisst inn personlig informasjon fra barn. Hvis du tror vi har samlet inn informasjon fra et barn, vennligst kontakt oss umiddelbart.'
      },
      changes: {
        title: '11. Endringer i denne erklæringen',
        content: 'Vi kan oppdatere denne personvernerklæringen fra tid til annen. Vi vil varsle deg om betydelige endringer ved å legge ut den nye erklæringen på plattformen vår og oppdatere "Sist oppdatert"-datoen. Din fortsatte bruk av våre tjenester etter endringer utgjør aksept av den oppdaterte erklæringen.'
      },
      contact: {
        title: '12. Kontakt oss',
        content: 'Hvis du har spørsmål om denne personvernerklæringen eller vår datapraksis, vennligst kontakt oss på:'
      }
    }
  },

  // Terms of Service
  terms: {
    title: 'Tjenestevilkår',
    lastUpdated: 'Sist oppdatert: 5. desember 2025',
    sections: {
      acceptance: {
        title: '1. Aksept av vilkår',
        content: 'Ved å få tilgang til eller bruke SocialChef ("Tjenesten"), samtykker du til å være bundet av disse tjenestevilkårene ("Vilkår"). Hvis du ikke godtar disse vilkårene, vennligst ikke bruk vår tjeneste. Disse vilkårene gjelder for alle brukere, inkludert besøkende, registrerte brukere og abonnenter.'
      },
      description: {
        title: '2. Beskrivelse av tjenesten',
        content: 'SocialChef er en AI-drevet plattform for sosiale medier. Vår tjeneste lar deg generere markedsføringsinnhold, lage bilder og bildetekster, planlegge innlegg og publisere innhold til tilkoblede sosiale medieplattformer. Funksjoner kan variere basert på abonnementsplanen din.'
      },
      eligibility: {
        title: '3. Kvalifisering',
        content: 'Du må være minst 18 år og i stand til å inngå en bindende avtale for å bruke vår tjeneste. Ved å bruke SocialChef bekrefter du at du oppfyller disse kvalifiseringskravene.'
      },
      account: {
        title: '4. Kontoregistrering og sikkerhet',
        intro: 'For å bruke visse funksjoner må du opprette en konto. Du samtykker til å:',
        items: {
          accurate: 'Oppgi nøyaktig, aktuell og fullstendig informasjon under registrering.',
          security: 'Opprettholde sikkerheten til passordet og kontolegitimasjonen din.',
          notify: 'Varsle oss umiddelbart om uautorisert tilgang eller sikkerhetsbrudd.',
          responsible: 'Akseptere ansvar for alle aktiviteter som skjer under kontoen din.'
        }
      },
      acceptableUse: {
        title: '5. Retningslinjer for akseptabel bruk',
        intro: 'Du samtykker til ikke å bruke tjenesten til å:',
        items: {
          illegal: 'Bryte gjeldende lover, forskrifter eller tredjeparts rettigheter.',
          harmful: 'Laste opp eller distribuere skadelig, støtende eller upassende innhold.',
          infringe: 'Krenke andres immaterielle rettigheter.',
          spam: 'Sende spam, uønskede meldinger eller delta i villedende praksis.',
          interfere: 'Forstyrre eller avbryte tjenesten eller dens infrastruktur.',
          impersonate: 'Utgi seg for en person eller enhet eller feilaktig fremstille din tilknytning.',
          reverse: 'Forsøke å reversere, dekompilere eller trekke ut kildekode fra vår tjeneste.'
        }
      },
      content: {
        title: '6. Brukerinnhold',
        ownership: 'Du beholder eierskapet til alt innhold du oppretter eller laster opp til SocialChef. Ved å bruke vår tjeneste gir du oss imidlertid en begrenset lisens til å bruke, lagre og behandle innholdet ditt utelukkende for å levere tjenesten.',
        license: 'For AI-generert innhold opprettet gjennom plattformen vår, mottar du en lisens til å bruke slikt innhold for forretningsformål, underlagt eventuelle begrensninger i abonnementsplanen din.',
        responsibility: 'Du er eneansvarlig for å sikre at innholdet ditt overholder gjeldende lover og ikke krenker tredjeparts rettigheter.'
      },
      socialMedia: {
        title: '7. Sosiale medier-integrasjon',
        content: 'Når du kobler til tredjepartskontoer for sosiale medier, autoriserer du oss til å få tilgang til og samhandle med disse kontoene på dine vegne. Du er ansvarlig for å overholde tjenestevilkårene til hver tilkoblet plattform. Vi er ikke ansvarlige for handlinger utført av eller begrensninger pålagt av tredjepartsplattformer.'
      },
      subscription: {
        title: '8. Abonnement og betaling',
        billing: 'Betalte abonnementer faktureres i henhold til planen du velger. Alle avgifter er ikke-refunderbare med mindre annet er oppgitt eller påkrevd ved lov.',
        cancellation: 'Du kan når som helst kansellere abonnementet ditt gjennom kontoinnstillingene dine. Kanselleringen trer i kraft ved slutten av gjeldende faktureringsperiode.',
        changes: 'Vi forbeholder oss retten til å endre prisene med rimelig varsel. Fortsatt bruk etter prisendringer utgjør aksept av nye priser.'
      },
      intellectual: {
        title: '9. Immaterielle rettigheter',
        content: 'SocialChef og dets originale innhold, funksjoner og funksjonalitet eies av oss og er beskyttet av internasjonale opphavsretts-, varemerke- og andre immaterielle rettigheter. Vår AI-teknologi, algoritmer og plattformdesign forblir vår eksklusive eiendom.'
      },
      disclaimer: {
        title: '10. Ansvarsfraskrivelse',
        content: 'TJENESTEN LEVERES "SOM DEN ER" OG "SOM TILGJENGELIG" UTEN GARANTIER AV NOE SLAG, ENTEN UTTRYKTE ELLER UNDERFORSTÅTTE. VI GARANTERER IKKE AT TJENESTEN VIL VÆRE UAVBRUTT, FEILFRI ELLER SIKKER. AI-GENERERT INNHOLD KAN INNEHOLDE FEIL ELLER UNØYAKTIGHETER, OG DU ER ANSVARLIG FOR Å GJENNOMGÅ ALT INNHOLD FØR PUBLISERING.'
      },
      limitation: {
        title: '11. Ansvarsbegrensning',
        content: 'I DEN MAKSIMALE UTSTREKNING TILLATT AV LOV, SKAL SOCIALCHEF IKKE VÆRE ANSVARLIG FOR NOEN INDIREKTE, TILFELDIGE, SPESIELLE, FØLGESKADER ELLER STRAFFEERSTATNING, INKLUDERT TAP AV FORTJENESTE, DATA ELLER FORRETNINGSMULIGHETER, SOM OPPSTÅR FRA DIN BRUK AV TJENESTEN.'
      },
      indemnification: {
        title: '12. Skadesløsholdelse',
        content: 'Du samtykker til å holde SocialChef, dets ledere, direktører, ansatte og agenter skadesløse fra eventuelle krav, skader, tap eller utgifter som oppstår fra din bruk av tjenesten, brudd på disse vilkårene eller krenkelse av tredjeparts rettigheter.'
      },
      termination: {
        title: '13. Oppsigelse',
        content: 'Vi kan suspendere eller avslutte tilgangen din til tjenesten når som helst for brudd på disse vilkårene eller av annen grunn etter vårt skjønn. Ved oppsigelse opphører retten din til å bruke tjenesten umiddelbart, selv om visse bestemmelser i disse vilkårene vil overleve.'
      },
      changes: {
        title: '14. Endringer i vilkårene',
        content: 'Vi forbeholder oss retten til å endre disse vilkårene når som helst. Vi vil varsle brukere om vesentlige endringer ved å legge ut de oppdaterte vilkårene på plattformen vår. Din fortsatte bruk av tjenesten etter endringer utgjør aksept av de endrede vilkårene.'
      },
      governing: {
        title: '15. Gjeldende lov',
        content: 'Disse vilkårene skal styres av og tolkes i samsvar med lovene i Norge, uten hensyn til lovvalgsprinsipper. Eventuelle tvister som oppstår fra disse vilkårene skal løses i norske domstoler.'
      },
      contact: {
        title: '16. Kontaktinformasjon',
        content: 'For spørsmål om disse tjenestevilkårene, vennligst kontakt oss på:'
      }
    }
  },

  // Inline Feedback
  feedback: {
    inlineTitle: 'Hjelp oss bli bedre',
    inlineSubtitle: 'Dette er ikke en del av innlegget',
    whatDidYouLike: 'Hva likte du eller likte du ikke med dette innlegget?',
    feedbackPlaceholder: 'Del hva som fungerte bra eller hva som kunne vært bedre...'
  },

  // Contact Feedback
  contactFeedback: {
    modalTitle: 'Send oss tilbakemelding',
    description: 'Har du et spørsmål, forslag eller problem? Vi vil gjerne høre fra deg!',
    messageLabel: 'Din melding',
    messagePlaceholder: 'Del dine tanker, forslag eller problemer...',
    characterCount: '{count}/2000',
    cancel: 'Avbryt',
    send: 'Send tilbakemelding',
    sending: 'Sender...',
    successMessage: 'Takk for tilbakemeldingen! Vi har mottatt meldingen din og vil ta kontakt snart.',
    errorRequired: 'Vennligst skriv inn en melding',
    errorFailed: 'Kunne ikke sende tilbakemelding. Vennligst prøv igjen.',
    buttonLabel: 'Tilbakemelding',
    buttonAriaLabel: 'Send tilbakemelding'
  },

  // Contact Page
  contact: {
    title: 'Ta Kontakt',
    subtitle: 'Har du et spørsmål eller vil du vite mer? Vi hører gjerne fra deg.',
    nameLabel: 'Navn',
    namePlaceholder: 'Ditt navn',
    emailLabel: 'E-post',
    emailPlaceholder: 'Din e-postadresse',
    subjectLabel: 'Emne',
    subjectPlaceholder: 'Velg et emne',
    messageLabel: 'Melding',
    messagePlaceholder: 'Fortell oss hva du tenker på...',
    submit: 'Send Melding',
    successTitle: 'Melding Sendt!',
    successMessage: 'Takk for at du tok kontakt. Vi svarer deg så snart som mulig.',
    error: 'Noe gikk galt. Vennligst prøv igjen senere.',
    orEmail: 'Eller send oss en e-post direkte',
    subjects: {
      general: 'Generell henvendelse',
      support: 'Støtte',
      partnership: 'Partnerskap',
      feedback: 'Tilbakemelding'
    }
  },

  // Generating Progress
  generatingProgress: {
    title: 'Lager innlegget ditt',
    hint: 'Dette tar vanligvis 20-50 sekunder',
    steps: {
      analyzing: 'Analyserer',
      designing: 'Designer',
      generating: 'Genererer',
      refining: 'Forbedrer',
      finalizing: 'Fullfører'
    }
  },

  // Delete Account Page
  deleteAccount: {
    pageTitle: 'Slett kontoen din',
    warning: 'Advarsel: Denne handlingen kan ikke angres',

    // Step 1 - Warning
    step1Title: 'Er du sikker?',
    step1Description: 'Sletting av kontoen din vil permanent fjerne all din data. Dette inkluderer:',
    dataList: {
      restaurants: 'Alle lagrede merker og deres innstillinger',
      posts: 'Alle genererte innlegg og bilder',
      favorites: 'Alle lagrede favoritter og planlagte innlegg',
      connections: 'Alle tilkoblede sosiale medier-kontoer',
      subscription: 'Ditt abonnement (vil bli kansellert umiddelbart)',
      history: 'All brukshistorikk og analyse'
    },

    // Step 2 - Confirmations
    step2Title: 'Bekreft at du forstår',
    confirmDataLoss: 'Jeg forstår at all min data vil bli permanent slettet',
    confirmNoRecovery: 'Jeg forstår at kontoen min ikke kan gjenopprettes etter sletting',
    confirmImmediateEffect: 'Jeg forstår at sletting trer i kraft umiddelbart og jeg vil bli logget ut',

    // Step 3 - Type DELETE

    // Reason
    reasonTitle: 'Hjelp oss bli bedre (valgfritt)',
    reasonDescription: 'Fortell oss hvorfor du forlater oss:',
    reasonPlaceholder: 'Hva kunne vi gjort bedre?',

    // Buttons
    continueButton: 'Fortsett',
    backButton: 'Gå tilbake',
    cancelButton: 'Avbryt',
    deleteButton: 'Slett kontoen min',
    deleting: 'Sletter...',

    // Final modal

    // Success/Goodbye
    goodbyeTitle: 'Ha det!',
    goodbyeMessage: 'Kontoen din har blitt slettet. Vi er lei for at du forlater oss.',
    goodbyeSubtext: 'Hvis du noen gang vil komme tilbake, er du alltid velkommen til å opprette en ny konto.',
    returnToHome: 'Tilbake til forsiden',

    // Errors
    errorGeneric: 'En feil oppstod under sletting av kontoen din. Vennligst prøv igjen.'
  },

  // Analytics Page
  analytics: {
    title: 'Analyse',
    subtitle: 'Følg med på innholdets ytelse og vekst',
    days: 'Dager',
    allTime: 'All tid',

    // Metrics
    totalPosts: 'Totalt innlegg',
    postsCreated: 'Innlegg opprettet',
    savedPosts: 'Lagret innhold',
    scheduledPosts: 'Planlagt',
    publishedPosts: 'Publisert',

    // Charts
    postingActivity: 'Publiseringsaktivitet',
    postsOverTime: 'Planlagte og publiserte innlegg over tid',
    postsActivity: 'Innlegg',
    platformDistribution: 'Plattformdistribusjon',
    postsByPlatform: 'Fordeling av innlegg per plattform',
    postStatus: 'Innleggsstatus',
    byStatus: 'Oversikt over alle planlagte innlegg',

    // Status labels
    published: 'Publisert',
    scheduled: 'Planlagt',
    cancelled: 'Avbrutt',
    failed: 'Mislyktes',
    pending: 'Ventende',
    draft: 'Utkast',
    allStatuses: 'Alle',

    // Platform tabs
    allPlatforms: 'Alle plattformer',
    platformFilter: 'Filtrer etter plattform',
    selectedPlatform: 'Valgt plattform',
    showingDataFor: 'Viser data for {platform}',
    noPlatformPosts: 'Ingen {platform}-innlegg ennå',
    noPlatformPostsDesc: 'Opprett og planlegg innlegg for denne plattformen for å se analyser her',
    createPost: 'Opprett innlegg',

    // Usage
    usageOverview: 'Bruksoversikt',
    monthlyUsage: 'Din nåværende faktureringsperiode',
    creditsUsed: 'Poeng brukt',
    used: 'brukt',
    subscription: 'Abonnement',
    restaurants: 'Merker',

    // Recent Activity
    recentActivity: 'Nylig aktivitet',
    latestPosts: 'Dine siste planlagte innlegg',
    noText: 'Ingen tekstinnhold',
    noRecentActivity: 'Ingen nylig aktivitet å vise',
    noDataYet: 'Ingen data tilgjengelig ennå',
    postImage: 'Innleggsbilde',
    viewOn: 'Se på {platform}',

    // Table headers
    post: 'Innlegg',
    platforms: 'Plattformer',
    restaurant: 'Merke',
    status: 'Status',
    date: 'Dato',
    links: 'Lenker',
    video: 'Video',
    errorReason: 'Feil',
    unknownError: 'Innlegget kunne ikke publiseres. Prøv igjen eller kontakt support.',

    // Pagination
    page: 'Side',
    of: 'av',

    // Post Modal
    postDetails: 'Innleggsdetaljer',
    postContent: 'Innleggsinnhold',
    viewOnPlatforms: 'Se på plattformer',

    // Engagement metrics
    engagement: 'Engasjement',
    likes: 'Likes',
    comments: 'Kommentarer',
    shares: 'Delinger',
    reach: 'Rekkevidde',
    views: 'Visninger (Rekkevidde)',
    impressions: 'Visninger',
    engagementRate: 'Engasjementsrate',
    totalEngagement: 'Totalt engasjement',
    averageEngagement: 'Gjennomsnittlig engasjement',
    averageEngagementRate: 'Gjennomsnittlig engasjementsrate',
    topPerformingPosts: 'Beste innlegg',
    topPerforming: 'Beste innlegg',
    highestEngagement: 'Innlegg med høyest engasjementsrate',
    performance: 'Ytelse',
    noPerformanceData: 'Publiser innlegg og synkroniser metrikker for å se beste innlegg',
    viewsTooltip: 'Total rekkevidde på tvers av alle plattformer',
    engagementOverTime: 'Engasjement over tid',

    // Reach/impressions data info
    reachDataLimited: 'Visnings- og rekkeviddedataLimited',
    reachDataInfo: 'Visninger (rekkevidde/visninger) krever Business-kontoer med Insights API-tillatelser. Personlige kontoer viser bare likes, kommentarer og delinger. For å se visningsdata, koble til en Business- eller Creator-konto med riktige tillatelser.',
    reachDataUnavailable: 'Visningsdata krever Business-kontotillatelser',

    // Instagram views info (legacy)
    instagramViewsLimited: 'Instagram-visninger begrenset',
    instagramViewsInfo: 'Instagram-visninger krever Instagram Business-konto med Insights API-tillatelse. Viser for øyeblikket bare likes og kommentarer.',
    learnMore: 'Lær mer',

    // Sync status
    engagementSyncing: 'Synkroniserer engasjementsdata...',
    detailedBreakdown: 'Detaljert oversikt',
    chartsAndDistributions: 'Diagrammer og fordelinger for innholdet ditt',
    syncStatus: 'Synkroniseringsstatus',
    syncing: 'Synkroniserer...',
    lastUpdated: 'Sist oppdatert {time}',
    refreshMetrics: 'Oppdater metrikker',
    refreshing: 'Oppdaterer...',
    lastSynced: 'Sist synkronisert',
    notSynced: 'Engasjement ikke synkronisert ennå',

    // Time relative
    justNow: 'Akkurat nå',
    oneMinuteAgo: '1 minutt siden',
    minutesAgo: '{minutes} minutter siden',
    oneHourAgo: '1 time siden',
    hoursAgo: '{hours} timer siden',
    oneDayAgo: '1 dag siden',
    daysAgo: '{days} dager siden',

    // Errors and messages
    noEngagementData: 'Ingen engasjementsdata tilgjengelig. Klikk "Oppdater metrikker" for å synkronisere fra sosiale plattformer.',
    engagementUnavailable: 'Engasjementsmetrikker utilgjengelig',
    syncError: 'Kunne ikke synkronisere metrikker',
    reconnectRequired: 'Koble til {platform} på nytt for å se innsikt',
    noPublishedPosts: 'Ingen publiserte innlegg ennå. Publiser innlegg for å se engasjementsmetrikker!',
    engagementNotSynced: 'Engasjementsdata ikke synkronisert ennå. Klikk "Oppdater metrikker" for å synkronisere fra sosiale plattformer.',
    engagementFetchFailed: 'Kunne ikke hente engasjementsdata. Vennligst prøv å oppdatere.',
    engagementError: 'Feil ved lasting av engasjementsdata. Sjekk konsollen for detaljer.',
    refreshSuccess: 'Oppdatert {count} innlegg',
    refreshFailed: 'Kunne ikke oppdatere engasjementsdata. Backend synkroniserer kanskje ikke fra sosiale plattformer ennå.',
    refreshError: 'Feil ved oppdatering av engasjementsdata',

    // Empty State
    emptyStateTitle: 'På tide å lage innlegg!',
    emptyStateDescription: 'Når du begynner å lage og planlegge innhold, vil analysene dine vises her. La oss komme i gang!',
    createFirstPost: 'Lag ditt første innlegg'
  },

  // Referral Program
  referral: {
    // Landing Page
    landingTitle: 'Du er invitert!',
    landingSubtitle: 'Vennen din tror du vil elske Social Chef',
    benefitsTitle: 'Dine eksklusive fordeler',
    freeMonth: 'Første måned GRATIS',
    freeMonthDesc: 'Start med 30 dager helt gratis',
    fiftyOff: '50% rabatt i 2 måneder',
    fiftyOffDesc: 'Etter din gratis måned, betal halv pris i måned 2-3',
    fullAccess: 'Full tilgang',
    fullAccessDesc: 'Nyt alle premium-funksjoner fra dag én',
    getStarted: 'Kom i gang nå',
    invalidCode: 'Ugyldig vervekode',
    invalidCodeTitle: 'Ugyldig invitasjon',
    invalidCodeMessage: 'Denne vervekoden er ikke lenger gyldig. Du kan fortsatt registrere deg til full pris.',
    noCodeTitle: 'Ingen vervekode',
    noCodeDesc: 'Det ser ut som du ikke har en vervekode. Spør en venn om deres kode eller registrer deg direkte.',
    goToHome: 'Gå til hjemmesiden',
    signUpAnyway: 'Registrer deg likevel',
    validatingCode: 'Validerer invitasjonen din...',
    validationError: 'Kunne ikke validere vervekode. Vennligst prøv igjen.',
    invitedBy: 'Invitert av {name}',
    codeApplied: 'Vervekode ble brukt!',
    applyError: 'Kunne ikke bruke vervekode. Vennligst prøv igjen.',
    discountBadge: '1 måned GRATIS + 50% rabatt',
    ctaTitle: 'Klar til å komme i gang?',
    ctaDescription: 'Rabatten din blir automatisk brukt ved kjøp.',
    ctaNote: 'Opprett konto og rabatten venter på deg',

    // Profile Section
    sectionTitle: 'Verv en venn',
    yourCode: 'Din vervekode',
    copyCode: 'Kopier kode',
    copyLink: 'Kopier lenke',
    codeCopied: 'Kode kopiert!',
    linkCopied: 'Lenke kopiert!',
    shareLink: 'Del lenke',
    shareVia: 'Del via',
    share: 'Del',
    shareTitle: 'Bli med på Social Chef',
    shareText: 'Jeg har brukt Social Chef for merket mitt og elsker det! Registrer deg med lenken min for å få din første måned gratis + 50% rabatt i 2 måneder.',
    shareEmailSubject: 'Bli med på Social Chef - Få din første måned gratis!',

    // Stats
    stats: 'Vervestatistikk',
    totalReferrals: 'Totalt vervede',
    successfulReferrals: 'Vellykkede',
    pendingReferrals: 'Ventende',
    creditsEarned: 'Totalt opptjente kreditter',
    currentBalance: 'Nåværende saldo',
    referralHistory: 'Vervehistorikk',
    noReferrals: 'Ingen vervinger ennå. Del koden din for å begynne å tjene kreditter!',

    // Status Labels
    statusPending: 'Ventende',
    statusConverted: 'Registrert',
    statusCredited: 'Kreditert',
    statusExpired: 'Utløpt',

    // How It Works
    howItWorks: 'Slik fungerer det',
    step1Title: 'Del koden din',
    step1Desc: 'Send din unike vervelenke til venner',
    step2Title: 'Venn abonnerer',
    step2Desc: 'De får en gratis måned + 50% rabatt i 2 måneder',
    step3Title: 'Du tjener kreditter',
    step3Desc: 'Få kontokreditt tilsvarende 50% av 2 måneder',

    // Errors
    requiresSubscription: 'Vervekoder er tilgjengelig for aktive månedlige eller årlige abonnenter',
    alreadyReferred: 'Du har allerede brukt en vervekode',
    cannotUsOwnCode: 'Du kan ikke bruke din egen vervekode',
    codeNotFound: 'Vervekode ikke funnet',
    codeInactive: 'Denne vervekoden er ikke lenger aktiv'
  },

  // Post Type Selection
  // Brand Filter
  brandFilter: {
    selectBrands: 'Velg merker',
    searchBrands: 'Søk etter merker...',
    brandsSelected: '{count} merke valgt | {count} merker valgt',
    noBrandsFound: 'Ingen merker funnet',
    tryDifferentSearch: 'Prøv et annet søkeord',
    clearAll: 'Fjern alle',
    applyFilters: 'Bruk filtre'
  },

  // Filter Bar
  filters: {
    title: 'Filtre',
    clearAll: 'Fjern alle',
    platforms: 'Plattformer',
    platformsCount: 'Plattformer ({count})',
    brands: 'Merker',
    brandsCount: 'Merker ({count})',
    contentType: 'Innholdstype',
    contentTypeCount: 'Innholdstype ({count})',
    newestFirst: 'Nyeste først',
    oldestFirst: 'Eldste først',
    active: 'Aktive:',
    images: 'Bilder',
    videos: 'Videoer'
  },

  postType: {
    label: 'Innleggstype',
    selectType: 'Innleggstype',
    feed: 'Vanlig innlegg',
    feedDesc: 'Vanlig innlegg på tidslinje/profil',
    story: 'Story',
    storyDesc: '24-timers story (bilde eller video)',
    storyExpiryNotice: 'Stories utløper etter 24 timer og har muligens ikke permanente lenker',
    reel: 'Reel',
    reelDesc: 'Kortformat innhold (bilde eller video)',
    carousel: 'Karusell',
    carouselDesc: '2-10 bilder/videoer',
    notSet: 'Ikke angitt',
    multiple: '{count} typer'
  },

  // App Landing Page
  appLanding: {
    nav: {
      features: 'Funksjoner',
      pricing: 'Priser',
      howItWorks: 'Hvordan det fungerer',
      getEarlyAccess: 'Få tidlig tilgang'
    },
    hero: {
      badge: 'Kommer snart til iOS og Android',
      headline: 'Din autonome ansatt for sosiale medier,',
      headlineAccent: 'i lommen din',
      subheadline: 'Bygget for bedriftseiere som heller vil drive sin bedrift enn sin Instagram.',
      ctaPrimary: 'Få tidlig tilgang',
      ctaSecondary: 'Se hvordan det fungerer',
      floatingBadge1: 'Publisert til Instagram',
      proofQuote: 'SocialChef sparte meg 15 timer i uken på innholdsproduksjon. Det er som å ha et helt markedsføringsteam.',
      proofAuthor: 'Taieb C.',
      proofRole: 'CEO, Rekrutteringsplattform'
    },
    builtFor: {
      eyebrow: 'Bygget for deg',
      title: 'Designet for bedrifter som din',
      subtitle: 'Enten du driver en restaurant, en bilvask eller en voksende startup — SocialChef håndterer sosiale medier slik at du slipper.',
      persona1Title: 'Restaurant og servering',
      persona1Pain: 'For opptatt på kjøkkenet til å tenke på Instagram.',
      persona1Result: 'SocialChef poster fristende innhold på autopilot.',
      persona2Title: 'Lokale tjenestebedrifter',
      persona2Pain: 'Hendene er alltid fulle — ingen tid til sosiale medier.',
      persona2Result: 'Kunder finner deg på nett uten at du løfter en finger.',
      persona3Title: 'Voksende startups',
      persona3Pain: 'Trenger markedsføring, men har ikke råd til et team.',
      persona3Result: 'Profesjonell tilstedeværelse på sosiale medier fra dag én.',
      persona4Title: 'Flerlokasjon-merkevarer',
      persona4Pain: 'Å administrere flere merkevarer på tvers av plattformer er et mareritt.',
      persona4Result: 'Ett dashbord for å håndtere alle merkevarene dine enkelt.'
    },
    socialProof: {
      platforms: 'Fungerer med'
    },
    pricing: {
      eyebrow: 'Priser',
      title: 'Enkle, transparente priser',
      subtitle: 'Velg planen som passer din bedrift. Spar 50% med årlig fakturering.',
      monthly: 'Månedlig',
      annual: 'Årlig',
      save: 'Spar 50%',
      month: 'md',
      year: 'år',
      popular: 'Mest populær',
      cta: 'Få tidlig tilgang',
      pro: 'Pro',
      business: 'Business',
      yearlySavePro: 'Spar $474/år',
      yearlySaveBusiness: 'Spar $894/år',
      featureAiChat: 'AI-chat og innholdsproduksjon',
      featurePlanning: 'Innholdsplanlegging og kalender',
      featurePublishing: 'Innleggshåndtering og publisering',
      featureAnalytics: 'Analyser og innsikt',
      featureDesign: 'Designstudio',
      featureAds: 'Google, Facebook og Pinterest-annonser',
      featureAssets: 'Ressurshåndtering',
      featureTeam: 'Teamsamarbeid',
      featureBrandVoice: 'Merkevare-stemmetrening',
      featureCompetitor: 'Konkurrentintelligens',
      featureMultiBrand: 'Flermerkevare-håndtering',
      featureSupport: 'Støtte',
      supportEmail: 'E-post',
      supportPriority: 'Prioritert'
    },
    aiCreation: {
      eyebrow: 'Smart innholdsmotor',
      title: 'Se innholdet ditt bli til',
      subtitle: 'Fra en enkel beskrivelse til publisert innhold — se den smarte produksjonslinjen i aksjon',
      promptTitle: 'AI-drevne forslag',
      promptDesc: 'SocialChef lager proaktivt innleggsideer basert på merkevaren din, publikum og trender.',
      promptGreeting: 'Hei! Jeg har satt sammen en innleggsidé for Jungel Pizza i dag. Hva synes du?',
      promptSuggestionCaption: 'Fredagsvibes & din beste pizza — fersk fra steinovnen',
      promptToneBadge: 'Profesjonell',
      generateTitle: 'Smart innholdsgenerering',
      generateDesc: 'SocialChef skriver tekst, velger bilder og lager plattformoptimaliserte innlegg.',
      adaptTitle: 'Flerplattform-tilpasning',
      adaptDesc: 'Innhold tilpasses automatisk til hver plattforms format og beste praksis.',
      scheduleTitle: 'Planlegg og publiser',
      scheduleDesc: 'Alle plattformer, når som helst. Planlegg feed-innlegg, reels, stories, karuseller og mer — eller la SocialChef velge det beste tidspunktet for publikummet ditt.',
      scheduleStageDesc: 'Alle plattformer, alle formater, til perfekt tid',
      badgeScheduled: 'Planlagt',
      badgePublished: 'Publisert',
      dayMon: 'Man',
      dayTue: 'Tir',
      dayWed: 'Ons',
      dayThu: 'Tor',
      dayFri: 'Fre',
      postBrandName: 'Din merkevare',
      postTimestamp: 'Akkurat nå',
      postTabFeed: 'Feed',
      postTabReel: 'Reel',
      postTabStory: 'Story',
      postTabCarousel: 'Karusell',
      postTabText: 'Tekst',
      adaptPublishAnywhere: 'Publiser overalt, når som helst',
      postToneBadge: 'Uformell',
      postCaption: 'Fredagsvibes & din beste pizza — fersk fra steinovnen hver helg',
      postCaptionMore: 'Kom og prøv vår nye trøffelpizza denne fredagen!',
      postPublishNow: 'Publiser nå',
      postSchedule: 'Planlegg',
      postEdit: 'Rediger',
      postInputPlaceholder: 'Melding...',
      // Tab labels
      promptTab: 'AI foreslår',
      generateTab: 'Lag innlegg',
      adaptTab: 'Tilpass plattformer',
      scheduleTab: 'Planlegg og publiser',
      // Step pills
      promptPill1: 'Merkevare-stemme',
      promptPill2: 'Trender',
      promptPill3: 'Målgruppedata',
      generatePill1: 'AI-tekstskriving',
      generatePill2: 'Hashtag-AI',
      generatePill3: 'Flerformat',
      adaptPill1: 'Instagram',
      adaptPill2: 'Facebook',
      adaptPill3: 'LinkedIn',
      adaptPill4: 'TikTok',
      schedulePill1: 'Beste-tid AI',
      schedulePill2: 'Alle plattformer',
      schedulePill3: 'Auto-publisering',
      // Pause hint
      pauseHint: 'pauset',
      // Adapt footer
      adaptFooter: 'Tilpasset for hver plattform, automatisk',
      adaptChip1: 'Tekstlengde',
      adaptChip2: 'Antall hashtags',
      adaptChip3: 'Bildebeskjæring',
      adaptChip4: 'Tone',
      // Calendar
      calTitle: 'Planlegg og publiser',
      calSubtitle: 'AI velger det beste tidspunktet for publikummet ditt',
      // Chat actions
      chatUseThis: 'Bruk dette',
      chatRegenerate: 'Regenerer',
      chatTyping: 'Perfekt! Planlegg dette til i morgen på Facebook, Instagram og LinkedIn',
      // Editor
      genEditorTitle: 'Nytt innlegg — Jungel Pizza',
    },
    adsManager: {
      eyebrow: 'Annonseadministrasjon',
      title: 'Kjør annonser som en proff. Uten byrå.',
      subtitle: 'Opprett og administrer Meta-, Google- og X-annonser rett fra appen. Smart tekstskriving, målrettingsoptimalisering og automatisert rapportering.',
      roas: 'ROAS',
      cpc: 'Gj.sn. CPC',
      conversions: 'Konverteringer',
      spend: 'Totalt forbruk',
      campaignTitle: 'Sommerkolleksjon-kampanje',
      active: 'Aktiv',
      impressions: 'Visninger',
      clicks: 'Klikk'
    },
    cinematic: {
      featureTitleChat: 'AI Chat-Assistent',
      featureDescChat: 'Fortell den hva du trenger — den kjenner merkevaren din.',
      featureTitleStrategy: 'Smart Innholdsstrategi',
      featureDescStrategy: 'En hel uke med innlegg, planlagt på sekunder.',
      featureTitleDesign: 'Innebygd Designstudio',
      featureDescDesign: 'Rediger visuelt uten å forlate appen.',
      featureTitlePublish: 'Publiser med Ett Klikk',
      featureDescPublish: 'Publiser til alle plattformer samtidig.',
      featureTitleCalendar: 'Visuell Innholdskalender',
      featureDescCalendar: 'Se hele timeplanen din med ett blikk.',
      featureTitleAnalytics: 'Sanntidsanalyser',
      featureDescAnalytics: 'Spor ytelse på tvers av alle plattformer.',
      featureTitleAds: 'Annonsekampanje-Styring',
      featureDescAds: 'Start betalte kampanjer på minutter.',
      featureTitleCta: 'Klar til å begynne?',
      featureDescCta: 'Bli med bedrifter som allerede sparer timer hver uke.',
      ctaPhoneHeadline: 'Hva venter du på?',
      ctaPhoneSubtext: 'Det publiserer seg ikke selv uten SocialChef.',
      ctaPhoneButton: 'Kom i gang',
      chatAiGreeting: 'Hei! Jeg har analysert merkevaren din. Klar til å lage innhold som matcher stemmen din?',
      chatUserReply1: 'Flott! Planlegg uken min på alle plattformer',
      chatAiStrategy: 'Her er din optimaliserte innholdsplan for Vetted denne uken:',
      chatCalendarTitle: 'Ukentlig innholdsplan',
      planMonDay: 'Man',
      planMonDesc: 'Tankelederartikkel',
      planWedDay: 'Ons',
      planWedDesc: 'Teamkultur bak kulissene',
      planFriDay: 'Fre',
      planFriDesc: 'Produktfunksjon i fokus',
      chatCalendarCount: '3 innlegg optimert per plattform',
      chatUserReply2: 'Perfekt — publiser tankeleder-innlegget nå!',
      chatInputPlaceholder: 'Melding...',
      attachTakePhoto: 'Ta bilde',
      attachChooseAssets: 'Velg fra bilder',
      attachDesignStudio: 'Designstudio',
      designTitle: 'Designstudio',
      designCropBg: 'Beskjær',
      designRatio: 'Format',
      designText: 'Tekst',
      designDraw: 'Tegn',
      designCta: 'CTA',
      designOverlayText: 'Fremtiden for rekruttering',
      designPrompt: 'Legg til merkevaregradienten vår og ren typografi',
      publishWhere: 'Hvor vil du publisere?',
      publishCaption: 'Hvordan vi vokste 340% i Q1: Strategien bak tallene',
      publishHashtag1: '#Web3',
      publishHashtag2: '#FremtidensArbeid',
      publishFeed: 'Feed',
      publishStory: 'Story',
      publishCarousel: 'Karusell',
      publishNow: 'Publiser nå',
      publishSchedule: 'Planlegg',
      publishSuccess: 'Publisert!',
      analyticsTitle: 'Analyser',
      analyticsOverview: 'Oversikt',
      analyticsImpressions: 'Visninger',
      analyticsReach: 'Rekkevidde',
      analyticsEngagement: 'Engasjement',
      analyticsClicks: 'Klikk',
      analyticsPublished: 'Publisert',
      analyticsPosts: 'Innlegg',
      analyticsTotalSpend: 'Totalt forbruk',
      analyticsCtr: 'CTR',
      analyticsPerformanceTrend: 'Ytelsesutvikling',
      analyticsOrganic: 'Organisk',
      analyticsPaid: 'Betalt',
      analytics7Days: '7 dager',
      analytics30Days: '30 dager',
      analytics90Days: '90 dager',
      analyticsChartTitle: 'Engasjement over tid',
      analyticsPlatformTitle: 'Plattformytelse',
      calTitle: 'Kalender',
      calBrand: 'Vetted',
      calMonth: 'Mars 2026',
      calSelectedDay: 'Onsdag, 25. mars',
      calPostTitle: 'Personlig Interaksjon',
      calPostPlatform: 'Facebook',
      calPostStatus: 'Planlagt 10:00',
      calPost2Title: 'Sommerstemning-kolleksjon',
      calPost2Platform: 'Instagram',
      calPost2Status: 'Planlagt 14:00',
      adsCreateTitle: 'Opprett kampanje',
      adsPlatformLabel: 'Plattform',
      adsObjectiveLabel: 'Mål',
      adsObjectiveReach: 'Rekkevidde',
      adsObjectiveEngagement: 'Engasjement',
      adsObjectiveClicks: 'Klikk',
      adsBudgetLabel: 'Daglig budsjett',
      adsDurationLabel: 'Varighet',
      adsBudgetValue: '250 kr / dag',
      adsDurationValue: '7 dager',
      adsLaunch: 'Start kampanje',
      adsSuccessTitle: 'Kampanje opprettet!',
      adsEstReach: 'Est. rekkevidde',
      adsTotalBudget: 'Totalt budsjett',
      adsEstCtr: 'Est. CTR',
      publishCardIntro: 'Her er innlegget ditt, klart til publisering:',
      publishedBadge: 'Publisert',
      publishedDate: 'Tir, 17. mars · 20:41',
      publishedAgo: '1d siden',
      publishedAccount: 'SocialChef',
      publishedFeedLink: 'Feed',
      publishedMoreLikeThis: 'Mer som dette',
      publishedLessLikeThis: 'Mindre som dette',
    },
    featureShowcase: {
      eyebrow: 'SMART INNHOLDSMOTOR',
      title: 'Se innholdet ditt bli til',
      subtitle: 'Fra en enkel beskrivelse til publisert innhold — se den smarte produksjonslinjen i aksjon.',
      tabAnalytics: 'Analyser',
      tabCalendar: 'Kalender',
      tabCompetitor: 'Konkurrentinnsikt',
      tabDesignBuilder: 'Designverktøy',
      tabAds: 'Annonser',
      tabAI: 'AI-assistent',
      tabPublishing: 'Publisering',
    },
    designBuilder: {
      eyebrow: 'Designverktøy',
      title: 'Lag visuelt innhold som stopper scrollingen',
      subtitle: 'Designverktøy for sosiale medier. Maler, merkevarefarger, smart bildegenerering — alt på ett sted.',
      background: 'Bakgrunn',
      backgroundDesc: 'Gradienter, farger eller genererte scener',
      image: 'Bildelag',
      imageDesc: 'Genererte eller opplastede medier',
      text: 'Tekstoverlegg',
      textDesc: 'Overskrifter, tekster og handlingsknapper',
      video: 'Videogenerering',
      videoDesc: 'AI-drevet video fra tekst eller bilder',
      branding: 'Merkevarepakke',
      brandingDesc: 'Logo, farger og fonter brukes automatisk',
      tploceanName: 'Hav',
      tploceanEyebrow: 'Smarte sosiale medier',
      tploceanHeadline: 'Innholdet ditt, på autopilot',
      tploceanSubline: 'Skaper, planlegger og publiserer — autonomt, 24/7',
      tplcoastalName: 'Kyst',
      tplcoastalEyebrow: 'Designbygger',
      tplcoastalHeadline: 'Visuelt som stopper scrolling',
      tplcoastalSubline: 'Maler, merkefarger og smart generering på ett sted',
      tplpremiumName: 'Premium',
      tplpremiumEyebrow: 'Merkevareidentitet',
      tplpremiumHeadline: 'Løft merkevarens tilstedeværelse',
      tplpremiumSubline: 'Eksklusive maler med dine farger, fonter og logo innebygd',
      formatimage: 'Bilde',
      formatvideo: 'Video',
      formatcarousel: 'Karusell',
      designCafeBrand: 'Hjørnekafeen',
      designCafeHeadline: 'Ny sommermeny',
      designCafeSubline: 'Nye sesongbaserte retter — bestill bord i dag',
      designSalonBrand: 'Glow Studio',
      designSalonHeadline: 'Forvandle stilen din',
      designSalonSubline: 'Se vår nyeste stylingvideo',
      designRetailBrand: 'Urban Threads',
      designRetailHeadline: 'Nye produkter ute nå',
      designRetailSubline: 'Sveip gjennom ukens kolleksjon'
    },
    calendar: {
      eyebrow: 'Innholdskalender',
      title: 'Hele uken din, planlagt',
      subtitle: 'Planlegg uken eller måneden med dine mål og merkevarebudskap — alt på ett sted.',
      thisWeek: 'Denne uken',
      autoSchedule: 'Autoplanlegging',
      autoScheduleDesc: 'AI velger de beste tidspunktene for hver plattform',
      multiPlatform: 'Flere plattformer',
      multiPlatformDesc: 'Én kalender for alle sosiale kontoer',
      contentGoals: 'Innholdsmål',
      contentGoalsDesc: 'Sett ukentlige temaer og merkevarebudskap',
      bulkImport: 'Masseimport',
      bulkImportDesc: 'Importer innholdsplaner fra CSV- eller XLSX-filer',
      viewFull: 'Se full kalender',
      weekSchedule: 'Denne ukens plan',
      types: {
        feed: 'Innlegg',
        reel: 'Reel',
        story: 'Story',
        carousel: 'Karusell',
      },
      post1: 'Ny sommerkolleksjon — ferske stiler kommer...',
      post2: 'Vår mest populære tjeneste, nå med ny...',
      post3: 'Topp 5 ting kundene elsket denne måneden...',
      post4: 'Bak kulissene i studioet vårt i dag...',
      post5: 'Helgens spesialtilbud — bestill din plass...',
      post6: 'Nye varer nettopp ankommet fra leverandørene...',
    },
    analytics: {
      eyebrow: 'Analysepanel',
      title: 'Vet hva som fungerer',
      subtitle: 'Følg ytelse på tvers av alle plattformer med sanntidsanalyser og smarte innsikter.',
      followers: 'Følgere',
      engagement: 'Engasjement',
      reach: 'Rekkevidde',
      posts: 'Innlegg',
      chartTitle: 'Engasjementsrate',
      chartPeriod: 'Siste 7 dager'
    },
    competitor: {
      eyebrow: 'Konkurrentintelligens',
      title: 'Hold deg foran konkurrentene',
      subtitle: 'Overvåk konkurrentaktivitet, sammenlign ytelse og oppdag innholdsgap.',
      dashTitle: 'Konkurrentpanel',
      followers: 'Følgere',
      engagement: 'Engasjement',
      postsMonth: 'Innlegg/md',
      benchmarking: 'Benchmarking',
      benchmarkingDesc: 'Sammenlign dine tall side om side med konkurrentene',
      contentGaps: 'Innholdsgap',
      contentGapsDesc: 'Oppdag temaer konkurrentene dekker som du ikke gjør',
      trendAlerts: 'Trendvarsler',
      trendAlertsDesc: 'Bli varslet når konkurrenter endrer strategi',
      shareOfVoice: 'Andel av stemme',
      shareOfVoiceDesc: 'Følg merkevarens synlighet mot konkurrentene'
    },
    aiAssistant: {
      eyebrow: 'AI-assistent',
      title: 'Din kreative partner, tilgjengelig 24/7',
      subtitle: 'Beskriv hva du trenger og la AI lage innlegg, bilder og videoer som matcher merkevaren din — med din stemme, farger og stil.',
      smartCreation: 'Smart oppretting',
      smartCreationDesc: 'Beskriv hva du vil ha, AI lager det',
      brandVoice: 'Merkevarestemme',
      brandVoiceDesc: 'Innholdet matcher din unike tone automatisk',
      multiFormat: 'Flere formater',
      multiFormatDesc: 'Innlegg, stories, reels og karuseller fra én beskrivelse',
      refinement: 'Iterer og finpuss',
      refinementDesc: 'Finjuster til det er perfekt, AI lærer dine preferanser',
      userPrompt: 'Hva bør jeg publisere denne uken? Jeg vil øke engasjementet.',
      aiResponse: 'Basert på analysene dine gir Reels 3x mer rekkevidde. Jeg foreslår en miks: 2 Reels, 1 karusell og 1 story-avstemning.',
      aiGenerated: 'Jeg har laget utkast til alle 4 innleggene med tekst, hashtags og bildekonsepter — klare for gjennomgang.',
      userReply: 'Elsker det — planlegg Reels til tirsdag og torsdag',
      aiConfirm: 'Ferdig! Reels planlagt til optimale tidspunkter. Jeg publiserer automatisk til Instagram, TikTok og Facebook.',
    },
    publishing: {
      eyebrow: 'Flerplattform-publisering',
      title: 'Ett klikk. Alle plattformer.',
      subtitle: 'Publiser til Facebook, Instagram, TikTok, X, LinkedIn og Pinterest samtidig — hvert innlegg auto-optimalisert per plattform.',
      oneClick: 'Ett-klikks publisering',
      oneClickDesc: 'Send til alle plattformer samtidig',
      platformOptimize: 'Plattformoptimalisering',
      platformOptimizeDesc: 'Justerer format, hashtags og lengde per plattform automatisk',
      sixPlatforms: '6+ plattformer',
      sixPlatformsDesc: 'Facebook, Instagram, TikTok, X, LinkedIn, Pinterest',
      smartTiming: 'Smart timing',
      smartTimingDesc: 'AI velger optimalt publiseringstidspunkt per plattform',
      postTitle: 'Lansering av sommermeny',
      sent: 'Sendt',
      optimized: 'Optimalisert',
    },
    testimonials: {
      eyebrow: 'Anmeldelser',
      title: 'Elsket av SMB-er overalt',
      subtitle: 'Se hva tidlige brukere sier om SocialChef.',
      testimonial1: 'SocialChef sparte meg 15 timer i uken på innholdsproduksjon. Den forstår faktisk merkevare-stemmen min — det er som å ha et helt markedsføringsteam.',
      testimonial2: 'Autopilot-funksjonen er utrolig. Jeg satte den opp én gang og sosiale medier-kontoene mine har vokst av seg selv i måneder.',
      testimonial3: 'Å administrere 5 merkevarer pleide å være et mareritt. Nå gjør jeg alt fra ett dashbord på 30 minutter om dagen.',
      testimonial4: 'Som bedriftseier hadde jeg aldri tid til sosiale medier. SocialChef håndterer alt — fra profesjonelle innlegg til sesongkampanjer. Mine online-bestillinger har doblet seg.',
      testimonial5: 'Å drive en bilvask betyr at hendene mine alltid er fulle. SocialChef holder sosiale medier aktive uten noen innsats. Kunder forteller meg at de fant oss gjennom Instagram nå.',
      decentralizedHiringCeo: 'CEO, Desentralisert rekrutteringsplattform',
      orderingPlatformCeo: 'CEO, Bestillingsplattform',
      resortOwner: 'Resorteier',
      businessOwner: 'Bedriftseier',
      luxCarWashOwner: 'Eier, Lux Bilpleie'
    },
    earlyBird: {
      inputPlaceholder: 'Skriv inn din e-post',
      cta: 'Sikre min tidlige tilgang',
      successTitle: 'Du er med!',
      successMessage: 'Vi varsler deg ved lansering.',
      noCreditCard: 'Ingen kredittkort nødvendig',
      alreadyOnList: 'Du er allerede på ventelisten!',
      invalidEmail: 'Vennligst skriv inn en gyldig e-postadresse',
      error: 'Noe gikk galt. Vennligst prøv igjen.'
    },
    finalCta: {
      title: 'Klar til å automatisere sosiale medier?',
      subtitle: 'Bli med markedsførere som får tidlig tilgang til SocialChef.',
      cta: 'Få tidlig tilgang',
      proofQuote: 'Mine online-bestillinger har doblet seg siden jeg begynte å bruke SocialChef.',
      proofAuthor: 'Peter',
      proofRole: 'Bedriftseier'
    },
    footer: {
      copyright: '© {year} SocialChef. Alle rettigheter forbeholdt.',
      privacy: 'Personvernerklæring',
      terms: 'Vilkår for bruk',
      contact: 'Kontakt'
    }
  }
}
